(function () {
  var SIZES = ['S', 'M', 'L', 'XL', '2XL', '3XL'];
  var BIG = { '2XL': 1, '3XL': 1 };

  // "A4 Cooling Performance Tee [N3142]" line for a garment (brand bold, model as a small tag). Built with
  // textContent so names like "Port & Company" never go through innerHTML.
  function styleEl(g, extra) {
    if (!g || !g.brand) return null;
    var s = document.createElement('span');
    s.className = 'crew-kit-style' + (extra ? ' ' + extra : '');
    var b = document.createElement('strong');
    b.textContent = g.brand;
    s.appendChild(b);
    if (g.name) s.appendChild(document.createTextNode(' ' + g.name));
    if (g.model) {
      var m = document.createElement('span');
      m.className = 'crew-kit-style__model';
      m.textContent = g.model;
      s.appendChild(document.createTextNode(' '));
      s.appendChild(m);
    }
    return s;
  }

  // "Embroidered" / "Printed" marker for one garment. Rides inside the style line so it costs no
  // extra row on a phone. The value is the display string straight from the kit data - no lookup
  // map, so a typo shows up as a wrong word rather than a silently missing pill.
  function decEl(g) {
    if (!g || !g.deco) return null;
    var d = document.createElement('span');
    d.className = 'crew-kit-style__deco' + (g.deco === 'Embroidered' ? ' crew-kit-style__deco--emb' : '');
    d.textContent = g.deco;
    return d;
  }

  // Style line plus the decoration marker, for the two surfaces where the buyer is actually
  // choosing (the Globo colour dropdowns and the Executive pickers). The size-grid headings
  // deliberately do NOT get one: they sit one screen below the dropdowns and would restate it.
  function styleWithDeco(g, extra) {
    var s = styleEl(g, extra);
    var d = decEl(g);
    if (s && d) s.appendChild(d);
    return s || d;
  }

  function build(root) {
    var kit = [];
    try { kit = JSON.parse(root.getAttribute('data-kit') || '[]'); } catch (e) { return; }
    root.__crewKit = kit;
    // A garment may take its count from a variant option (Premium Tee Kit: "Shirts" 50 / 75 / 100 ...).
    kit.forEach(function (g) {
      g.baseCount = g.count;
      if (g.countFromVariant) { var n0 = variantCount(root, g.countFromVariant); if (n0 > 0) g.count = n0; }
    });
    if (root.hasAttribute('data-single')) {
      var q0 = singleQty(root);
      kit.forEach(function (g) { g.count = q0; });
    }
    var sized = kit.filter(function (g) { return g.sized !== false; });
    var wrap = root.querySelector('[data-crew-kit-groups]');
    if (!wrap || !sized.length) return;
    wrap.innerHTML = '';
    // Evan 2026-09-24: Crew Kit 100/200 shirts can be short sleeve, long sleeve or a mix. Groups that share a
    // "pool" are sized together (short + long must add up to the pool), and a Sleeves toggle shows one or both.
    var pooled = sized.filter(function (g) { return g.pool; });
    if (pooled.length) renderSleeves(root, wrap, pooled);
    sized.forEach(function (g) {
      var group = document.createElement('div');
      group.className = 'crew-kit-group';
      group.setAttribute('data-group', g.key);
      group.setAttribute('data-count', g.count);
      if (g.pool) {
        group.setAttribute('data-pool', g.pool);
        group.setAttribute('data-pool-count', g.poolCount || g.count);
        if (g.sleeve) group.setAttribute('data-sleeve', g.sleeve);
      }
      var head = document.createElement('div');
      head.className = 'crew-kit-group__head';
      var title = document.createElement('span');
      title.className = 'crew-kit-group__title';
      var label = document.createElement('span');
      label.className = 'crew-kit-group__label';
      label.textContent = g.label;
      title.appendChild(label);
      var style = styleEl(g);
      if (style) title.appendChild(style);
      head.appendChild(title);
      var counter = document.createElement('span');
      counter.className = 'crew-kit-group__count';
      counter.setAttribute('data-counter', '');
      counter.textContent = '0 of ' + g.count + ' sized';
      head.appendChild(counter);
      group.appendChild(head);
      var grid = document.createElement('div');
      grid.className = 'crew-kit-group__grid';
      // a garment may carry its own size list and its own +$3 sizes (the hi-vis vest runs S/M, L/XL, 2XL/3XL, 4XL/5XL)
      var sizes = (g.sizes && g.sizes.length) ? g.sizes : SIZES;
      var bigList = (g.big && g.big.length) ? g.big : null;
      group.setAttribute('data-big', JSON.stringify(bigList || Object.keys(BIG)));
      sizes.forEach(function (sz) {
        var isBig = bigList ? bigList.indexOf(sz) >= 0 : !!BIG[sz];
        var cell = document.createElement('div');
        cell.className = 'crew-kit-cell' + (isBig ? ' is-big' : '');
        var id = 'ck-' + g.key + '-' + sz.replace(/[^A-Za-z0-9]+/g, '_');
        cell.innerHTML = '<label for="' + id + '">' + sz + (isBig ? '<small>+$3</small>' : '') + '</label>' +
          '<input type="number" inputmode="numeric" min="0" max="' + g.count + '" step="1" id="' + id + '" data-size="' + sz + '" placeholder="0" autocomplete="off">';
        grid.appendChild(cell);
      });
      group.appendChild(grid);
      var hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = 'properties[' + g.label + ' sizes]';
      hidden.setAttribute('data-summary', '');
      group.appendChild(hidden);
      wrap.appendChild(group);
    });
    wrap.addEventListener('input', function (ev) {
      if (ev.target && ev.target.matches && ev.target.matches('input[data-size]')) ev.target.classList.toggle('has-value', parseInt(ev.target.value, 10) > 0);
      var f = root.closest('form');
      if (f) f.__crewKitAddonDone = false; // sizes changed, so the next add prices its own 2XL+ pieces
      update(root);
    });
    update(root);
  }

  function groupTotals(root) {
    var out = [];
    root.querySelectorAll('.crew-kit-group').forEach(function (group) {
      var count = parseInt(group.getAttribute('data-count'), 10) || 0;
      var total = 0, big = 0, parts = [];
      var bigList = [];
      try { bigList = JSON.parse(group.getAttribute('data-big') || '[]'); } catch (e) { bigList = Object.keys(BIG); }
      group.querySelectorAll('input[data-size]').forEach(function (inp) {
        var v = parseInt(inp.value, 10);
        if (!(v > 0)) return;
        total += v;
        if (bigList.indexOf(inp.getAttribute('data-size')) >= 0) big += v;
        parts.push(inp.getAttribute('data-size') + ' ' + v);
      });
      out.push({ group: group, count: count, total: total, big: big, summary: parts.join(', ') });
    });
    return out;
  }

  // Groups that share data-pool (short + long sleeve shirts) are sized together: their totals add up to the pool.
  function poolTotals(root, totals) {
    var pools = {};
    totals.forEach(function (t) {
      var p = t.group.getAttribute('data-pool');
      if (!p || t.group.hidden) return;
      if (!pools[p]) pools[p] = { count: parseInt(t.group.getAttribute('data-pool-count'), 10) || t.count, total: 0, groups: [] };
      pools[p].total += t.total;
      pools[p].groups.push(t);
    });
    return pools;
  }

  function update(root) {
    var ok = true;
    var totals = groupTotals(root);
    var pools = poolTotals(root, totals);
    totals.forEach(function (t) {
      var c = t.group.querySelector('[data-counter]');
      var p = t.group.getAttribute('data-pool');
      if (t.group.hidden) { t.group.querySelector('[data-summary]').value = ''; return; }
      if (p && pools[p]) {
        var pool = pools[p];
        c.textContent = (pool.groups.length > 1 ? t.total + ' here \u00b7 ' : '') + pool.total + ' of ' + pool.count + ' sized';
        c.classList.toggle('is-done', pool.total === pool.count);
        c.classList.toggle('is-over', pool.total > pool.count);
        t.group.querySelector('[data-summary]').value = t.summary ? t.summary + ' (' + t.total + ' total)' : '';
        if (pool.total !== pool.count) ok = false;
        return;
      }
      c.textContent = t.total + ' of ' + t.count + ' sized';
      c.classList.toggle('is-done', t.total === t.count);
      c.classList.toggle('is-over', t.total > t.count);
      t.group.querySelector('[data-summary]').value = t.summary ? t.summary + ' (' + t.total + ' total)' : '';
      if (t.total !== t.count) ok = false;
    });
    if (ok) hideError(root);
    // display only: a summary problem must never stop the size check or the add
    try { renderSummary(root); } catch (e) { if (window.console) console.warn('crew summary', e); }
    return ok;
  }

  // ---- Sleeves (short / long / mix) for pooled shirt groups (Evan 2026-09-24, Crew Kit 100/200) ----
  var LS_ADDON_HANDLE = 'long-sleeve-upgrade';
  var SLEEVE_LABELS = { short: 'All short sleeve', long: 'All long sleeve', hooded: 'All hooded long sleeve' };
  // Kit 100/200: short + long + a mix, long sleeves priced as an add-on. A pooled kit_json group may carry sleeveLabel
  // (button text), mix:false (no mix option) and addon:false (every sleeve at the kit price), e.g. the Performance Tee
  // Kit's short / long / hooded pick (Evan 2026-09-24).
  function sleeveCfg(pooled) {
    var opts = [], seen = {};
    pooled.forEach(function (g) {
      var k = g.sleeve || 'short';
      if (seen[k]) return;
      seen[k] = true;
      opts.push({ key: k, label: g.sleeveLabel || SLEEVE_LABELS[k] || ('All ' + k) });
    });
    var byVariant = pooled.filter(function (g) { return g.sleeveVariantValue; });
    return {
      opts: opts,
      mix: pooled.every(function (g) { return g.mix !== false; }),
      addon: pooled.every(function (g) { return g.addon !== false; }),
      note: pooled[0].sleeveNote || null,
      // Evan 2026-09-24 ("pricing should change depending on what you pick"): when the groups carry sleeveVariantValue the
      // style is a product option (default name "Style"), the theme's own variant pills pick it and price it, and the
      // Sleeves buttons are not drawn; the size grid and colour picker follow the chosen variant instead.
      fromVariant: byVariant.length ? (byVariant[0].sleeveFromVariant || 'Style') : null
    };
  }
  function sleeveModeFromVariant(root) {
    var cfg = sleeveCfgOf(root), form = root.closest('form');
    if (!cfg.fromVariant || !form) return null;
    var val = String(variantOptionValue(form, cfg.fromVariant) || '').trim().toLowerCase(), hit = null;
    (root.__crewKit || []).forEach(function (g) { if (!hit && g.pool && g.sleeveVariantValue && String(g.sleeveVariantValue).trim().toLowerCase() === val) hit = g; });
    return hit ? (hit.sleeve || 'short') : null;
  }
  function syncSleeveFromVariant(root) {
    var mode = sleeveModeFromVariant(root);
    if (mode && mode !== sleevesMode(root)) setSleeves(root, mode);
  }
  function sleeveCfgOf(root) {
    return root.__crewSleeves || { opts: [{ key: 'short', label: 'All short sleeve' }, { key: 'long', label: 'All long sleeve' }], mix: true, addon: true, note: null };
  }
  function sleevesMode(root) { return root.getAttribute('data-sleeves') || 'short'; }
  function poolCountOf(root) {
    var g = root.querySelector('.crew-kit-group[data-pool]');
    return g ? (parseInt(g.getAttribute('data-pool-count'), 10) || 0) : 0;
  }
  function lsCountInput(root) { return root.querySelector('[data-ls-count]'); }
  function lsUnitCents(form) {
    var fabric = String(form ? variantOptionValue(form, 'T-shirt') || '' : '').toLowerCase();
    return fabric.indexOf('cotton') >= 0 ? 800 : 300;
  }
  function renderSleeves(root, wrap, pooled) {
    var cfg = sleeveCfg(pooled);
    root.__crewSleeves = cfg;
    var pool = pooled[0].poolCount || pooled[0].count;
    var box = document.createElement('div');
    box.className = 'crew-kit-sleeves';
    if (cfg.fromVariant) {
      box.hidden = true;
      box.innerHTML = '<input type="hidden" name="properties[Sleeves]" data-sleeves-prop value="' + cfg.opts[0].label.replace(/"/g, '&quot;') + '">';
      var anchor0 = root.querySelector('[data-crew-kit-mode]') || wrap;
      anchor0.parentNode.insertBefore(box, anchor0);
      setTimeout(function () { setSleeves(root, sleeveModeFromVariant(root) || cfg.opts[0].key); }, 0);
      return;
    }
    var btns = cfg.opts.map(function (o) {
      return '<button type="button" class="crew-kit-mode__btn" data-sleeves="' + o.key + '" aria-pressed="false">' + o.label + '</button>';
    }).join('');
    if (cfg.mix) btns += '<button type="button" class="crew-kit-mode__btn" data-sleeves="mix" aria-pressed="false">Mix of both</button>';
    var note = cfg.note || (cfg.addon
      ? 'Long sleeves add $3 a piece in performance or $8 a piece in heavyweight cotton, added to your cart automatically.'
      : 'Same price whichever you pick. One style for the whole order.');
    box.innerHTML =
      '<div class="crew-kit-group__head"><span class="crew-kit-group__title"><span class="crew-kit-group__label">Sleeves</span></span></div>' +
      '<div class="crew-kit-sizes__mode crew-kit-sleeves__mode" data-crew-kit-sleeves role="group" aria-label="Sleeve style">' + btns + '</div>' +
      '<p class="crew-kit-sizes__intro crew-kit-sleeves__note">' + note + '</p>' +
      (cfg.mix
        ? '<div class="crew-kit-sleeves__count" data-ls-count-wrap hidden>' +
            '<div class="crew-kit-group__head"><span class="crew-kit-group__title"><span class="crew-kit-group__label">How many of each?</span></span>' +
              '<span class="crew-kit-group__count" data-ls-split-counter>0 of ' + pool + '</span></div>' +
            '<div class="crew-kit-sleeves__split">' +
              '<div class="crew-kit-cell"><label for="ck-ss-count">Short sleeve</label>' +
                '<input type="number" inputmode="numeric" min="0" max="' + pool + '" step="1" id="ck-ss-count" data-ss-count name="properties[Short sleeve count]" placeholder="0" autocomplete="off"></div>' +
              '<div class="crew-kit-cell"><label for="ck-ls-count">Long sleeve</label>' +
                '<input type="number" inputmode="numeric" min="0" max="' + pool + '" step="1" id="ck-ls-count" data-ls-count name="properties[Long sleeve count]" placeholder="0" autocomplete="off"></div>' +
            '</div>' +
            '<p class="crew-kit-sleeves__hint">Type one and we fill in the other. Together they make ' + pool + '.</p>' +
          '</div>'
        : '') +
      '<input type="hidden" name="properties[Sleeves]" data-sleeves-prop value="' + cfg.opts[0].label.replace(/"/g, '&quot;') + '">';
    // above the size-mode toggle, not inside the groups wrapper (hidden while sizes come later)
    var anchor = root.querySelector('[data-crew-kit-mode]') || wrap;
    anchor.parentNode.insertBefore(box, anchor);
    box.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('button[data-sleeves]') : null;
      if (!btn) return;
      e.preventDefault();
      setSleeves(root, btn.getAttribute('data-sleeves'));
    });
    box.addEventListener('input', function (e) {
      var t = e.target;
      if (!(t && t.hasAttribute && (t.hasAttribute('data-ls-count') || t.hasAttribute('data-ss-count')))) return;
      // the two boxes split the pool: typing in one fills the other with the rest
      var total = poolCountOf(root), ls = lsCountInput(root), ss = root.querySelector('[data-ss-count]');
      var v = parseInt(t.value, 10);
      if (t.value !== '' && !(v >= 0)) v = 0;
      if (v > total) { v = total; t.value = v; }
      var other = t === ls ? ss : ls;
      if (other) other.value = t.value === '' ? '' : String(total - v);
      syncSleeveSplit(root);
      var f = root.closest('form');
      if (f) f.__crewKitAddonDone = false;
      hideError(root);
      update(root);
    });
    setTimeout(function () { setSleeves(root, root.getAttribute('data-sleeves') || cfg.opts[0].key); }, 0);
  }
  function setSleeves(root, mode) {
    root.setAttribute('data-sleeves', mode);
    var form = root.closest('form');
    if (form) { form.__crewKitPass = false; form.__crewKitAddonDone = false; }
    root.querySelectorAll('[data-crew-kit-sleeves] button[data-sleeves]').forEach(function (b) {
      var on = b.getAttribute('data-sleeves') === mode;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    var prop = root.querySelector('[data-sleeves-prop]');
    if (prop) {
      var chosen = null;
      sleeveCfgOf(root).opts.forEach(function (o) { if (o.key === mode) chosen = o; });
      prop.value = mode === 'mix' ? 'Mix of short and long sleeve' : (chosen ? chosen.label : mode);
    }
    root.querySelectorAll('.crew-kit-group[data-sleeve]').forEach(function (group) {
      var s = group.getAttribute('data-sleeve');
      var hide = mode !== 'mix' && s !== mode;
      group.hidden = hide;
      if (hide) group.querySelectorAll('input[data-size]').forEach(function (inp) { inp.value = ''; inp.classList.remove('has-value'); });
    });
    // a sleeve style's colour picker only matters while that style is in the order; its select is disabled when hidden,
    // so an all-short order does not carry a "Long sleeve color" property
    if (form) {
      var showColor = {}, hideColor = {};
      (root.__crewKit || []).forEach(function (g) {
        if (!g.pool || !g.color) return;
        var on = mode === 'mix' || (g.sleeve || 'short') === mode;
        (on ? showColor : hideColor)[String(g.color).trim().toLowerCase()] = true;
      });
      form.querySelectorAll('.crew-kit-pick').forEach(function (p) {
        var l = p.querySelector('.crew-kit-pick__label');
        var t = (l && l.firstChild && l.firstChild.nodeType === 3 ? l.firstChild.textContent : (l ? l.textContent : '')).trim().toLowerCase();
        if (!hideColor[t] && !showColor[t]) return;
        var off = !!hideColor[t] && !showColor[t];
        p.hidden = off;
        p.style.display = off ? 'none' : '';   // the theme's .crew-kit-pick { display:flex } outranks [hidden]
        p.querySelectorAll('select, input').forEach(function (el) { el.disabled = off; });
      });
    }
    syncSleeveUi(root);
    hideError(root);
    update(root);
  }
  // the "how many long sleeve" box is only needed for a mix when sizes come later (sized now, the long sleeve grid says)
  function syncSleeveUi(root) {
    var w = root.querySelector('[data-ls-count-wrap]');
    if (!w) return;
    var show = sleevesMode(root) === 'mix' && isLater(root);
    w.hidden = !show;
    w.querySelectorAll('[data-ls-count], [data-ss-count]').forEach(function (inp) { inp.disabled = !show; });
    syncSleeveSplit(root);
  }
  // "N of 104" pill over the short / long boxes: green once the split adds up, red if a box is over the pool
  function syncSleeveSplit(root) {
    var c = root.querySelector('[data-ls-split-counter]');
    if (!c) return;
    var total = poolCountOf(root), ls = lsCountInput(root), ss = root.querySelector('[data-ss-count]');
    var n = (ls && parseInt(ls.value, 10) > 0 ? parseInt(ls.value, 10) : 0) + (ss && parseInt(ss.value, 10) > 0 ? parseInt(ss.value, 10) : 0);
    c.textContent = n + ' of ' + total;
    c.classList.toggle('is-done', n === total && n > 0);
    c.classList.toggle('is-over', n > total);
  }
  // long sleeve pieces to price: all of the pool, the mix count, or the long sleeve grid's total
  function lsTotal(root) {
    if (!root.querySelector('.crew-kit-group[data-pool]')) return 0;
    if (!sleeveCfgOf(root).addon) return 0;
    var mode = sleevesMode(root);
    if (mode === 'short') return 0;
    if (mode === 'long') return poolCountOf(root);
    if (isLater(root)) { var inp = lsCountInput(root); var n = inp ? parseInt(inp.value, 10) : 0; return n > 0 ? n : 0; }
    var n2 = 0;
    groupTotals(root).forEach(function (t) { if (t.group.getAttribute('data-sleeve') === 'long' && !t.group.hidden) n2 += t.total; });
    return n2;
  }
  function lsProblem(root) {
    if (!root.querySelector('.crew-kit-group[data-pool]')) return '';
    if (!sleeveCfgOf(root).mix) return '';
    if (sleevesMode(root) === 'mix' && isLater(root)) {
      var pool = poolCountOf(root), inp = lsCountInput(root), n = inp ? parseInt(inp.value, 10) : 0;
      if (!(n >= 1 && n <= pool - 1)) return 'Split the ' + pool + ' shirts: how many short sleeve and how many long sleeve? Enter at least 1 of each.';
    }
    return '';
  }
  var lsAddonVariants = null, lsAddonLoading = null;
  function loadLsAddon() {
    if (lsAddonVariants) return Promise.resolve(lsAddonVariants);
    if (lsAddonLoading) return lsAddonLoading;
    lsAddonLoading = fetch('/products/' + LS_ADDON_HANDLE + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { lsAddonVariants = p && p.variants ? p.variants : []; return lsAddonVariants; })
      .catch(function () { return []; });
    return lsAddonLoading;
  }
  function lsAddonVariantId(form, variants) {
    if (!variants || !variants.length) return null;
    var fabric = String(variantOptionValue(form, 'T-shirt') || '').trim().toLowerCase();
    var hit = null;
    variants.forEach(function (v) { if (!hit && String(v.title || '').trim().toLowerCase() === fabric) hit = v; });
    return (hit || variants[0]).id;
  }

  function showError(root, msg) {
    // a one-size single item hides the whole size block, so its message goes on the total line above Add To Cart
    if (root.hasAttribute('data-no-sizes')) {
      var t = singleTotalEl(root);
      if (t) { t.textContent = msg; t.classList.add('is-error'); t.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
    }
    var e = root.querySelector('[data-crew-kit-error]');
    if (!e) return;
    e.textContent = msg; e.hidden = false;
    root.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
  function hideError(root) {
    var e = root.querySelector('[data-crew-kit-error]');
    if (e) e.hidden = true;
  }

  function firstPickProblem(root) {
    var form = root.closest('form');
    var picks = form ? form.querySelector('[data-crew-kit-picks]') : null;
    if (!picks) return null;
    var missing = [];
    picks.querySelectorAll('input[data-required]').forEach(function (inp) {
      if (!inp.value.trim()) { missing.push(inp.closest('.crew-kit-pick').querySelector('.crew-kit-pick__label').firstChild.textContent.trim()); inp.classList.add('is-missing'); } else inp.classList.remove('is-missing');
    });
    return missing.length ? 'Please fill in: ' + missing.join(', ') + '.' : null;
  }

  // Single items (products tagged single-item, Evan 2026-09-17): one garment per order line. The minimum comes from the
  // root's data-single-min (8 embroidered, 12 printed) and the price per piece from data-tiers (one variant per order-size
  // tier: [{min, id, price in cents}]). The size grid's count follows the page's quantity box, an order under the minimum is
  // stopped with a message, the form's variant follows the tier, and a live total sits above Add To Cart. The theme also
  // puts the minimum on the quantity box and on the cart lines, and crew-cart-tiers.js re-prices a cart line whose
  // quantity moves into another tier.
  var SPOT_ADDON_VARIANT = 68009898770741, SPOT_CENTS = 400;
  function spotExtras(form) { var b = form && form.querySelector('[data-crew-spots]'); return b ? (parseInt(b.getAttribute('data-extras'), 10) || 0) : 0; }
  function spotAddonQty(root, form) { return spotExtras(form) * singleQty(root); }
  function singleMin(root) {
    var n = parseInt(root.getAttribute('data-single-min'), 10);
    return n > 0 ? n : 24;
  }
  function singleTiers(root) {
    if (!root.__crewTiers) {
      var t = [];
      try { t = JSON.parse(root.getAttribute('data-tiers') || '[]'); } catch (e) { t = []; }
      root.__crewTiers = t.filter(function (x) { return x && x.id; }).sort(function (a, b) { return a.min - b.min; });
    }
    return root.__crewTiers;
  }
  function singleTier(root, n) {
    var tiers = singleTiers(root), pick = null;
    tiers.forEach(function (x) { if (n >= x.min) pick = x; });
    return pick || tiers[0] || null;
  }
  function crewMoney(cents) {
    return (cents / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
  }
  function singleQtyInput(root) {
    var form = root.closest('form');
    if (!form) return null;
    // not form.id: the form's hidden <input name="id"> shadows that property
    var fid = form.getAttribute('id');
    return (fid && document.querySelector('input[name="quantity"][form="' + fid + '"]')) || form.querySelector('input[name="quantity"]');
  }
  // Dawn's product-info rewrites the box after every add without an input or change event, and drops it to 1 once the
  // cart holds the minimum of the product. Each color is its own order, so keep the box at the minimum or more.
  function pinSingleMin(root) {
    var inp = singleQtyInput(root), min = singleMin(root);
    if (!inp || inp.type === 'hidden') return;
    if (!(parseInt(inp.min, 10) >= min)) inp.min = min;
    if (!(parseInt(inp.value, 10) >= min)) inp.value = min;
  }
  function singleQty(root) {
    var inp = singleQtyInput(root);
    var n = inp ? parseInt(inp.value, 10) : singleMin(root);
    return n > 0 ? n : 0;
  }
  function singleTotalEl(root) {
    var form = root.closest('form');
    return form ? form.querySelector('[data-crew-single-total]') : null;
  }
  function setSingleCount(root) {
    var n = singleQty(root), min = singleMin(root);
    (root.__crewKit || []).forEach(function (g) { g.count = n; });
    root.querySelectorAll('.crew-kit-group').forEach(function (group) {
      group.setAttribute('data-count', n);
      group.querySelectorAll('input[data-size]').forEach(function (inp) { inp.max = n; });
    });
    var form = root.closest('form');
    var tier = singleTier(root, n);
    if (tier && form) {
      var idInput = form.querySelector('input[name="id"]');
      if (idInput && String(idInput.value) !== String(tier.id)) idInput.value = tier.id;
    }
    var t = singleTotalEl(root);
    if (t) {
      var unit = tier ? tier.price : (parseInt(t.getAttribute('data-unit-cents'), 10) || 0);
      t.setAttribute('data-unit-cents', unit);
      t.classList.toggle('is-error', n < min);
      t.textContent = n < min ? 'The minimum is ' + min + ' pieces.' : n + ' pieces at ' + crewMoney(unit + spotExtras(form) * SPOT_CENTS) + ' each: ' + crewMoney((unit + spotExtras(form) * SPOT_CENTS) * n) + ' + shipping and tax';
    }
    if (tier) {
      var scope = root.closest('section') || document;
      scope.querySelectorAll('[data-crew-tier]').forEach(function (row) {
        row.classList.toggle('is-active', parseInt(row.getAttribute('data-crew-tier'), 10) === tier.min);
      });
      scope.querySelectorAll('[id^="price-"] .price__regular .price-item--regular, [id^="price-"] .price-item--last').forEach(function (el) {
        el.textContent = crewMoney(tier.price);
      });
      scope.querySelectorAll('[data-crew-sticky-price]').forEach(function (el) { el.textContent = crewMoney(tier.price + spotExtras(form) * SPOT_CENTS) + ' each'; });
    }
    var e = root.querySelector('[data-crew-kit-error]');
    if (e && !e.hidden && n >= min && e.textContent.indexOf('The minimum is ') === 0) e.hidden = true;
    if (form) form.__crewKitAddonDone = false;
    update(root);
  }
  function initSingle(root) {
    if (!root.hasAttribute('data-single')) return;
    var inp = singleQtyInput(root);
    var form = root.closest('form');
    if (!inp && form) {
      // a template without the quantity block would add ONE piece, so post the minimum
      inp = document.createElement('input');
      inp.type = 'hidden'; inp.name = 'quantity'; inp.value = singleMin(root);
      form.appendChild(inp);
    }
    if (!root.__crewSingleSub && typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      root.__crewSingleSub = true;
      subscribe(PUB_SUB_EVENTS.quantityUpdate, function () { pinSingleMin(root); setSingleCount(root); });
    }
    pinSingleMin(root);
    if (inp && !inp.__crewSingle) {
      inp.__crewSingle = true;
      inp.addEventListener('input', function () { setSingleCount(root); });
      inp.addEventListener('change', function () { setSingleCount(root); });
    }
    setSingleCount(root);
  }

  // "Send sizes after my mockup" mode: the grids are hidden, the size rule and the $3 add-on are skipped,
  // and one line item property tells the shop the sizes are coming after proof approval.
  function isLater(root) {
    return root.classList.contains('is-sizes-later');
  }

  function setMode(root, mode) {
    var later = mode === 'later';
    var form = root.closest('form');
    if (form) {
      // Never let an add that was already in flight finish under the new mode.
      form.__crewKitPass = false;
      form.__crewKitAddonDone = false;
      form.__crewKitCancelAddon = false;   // was `= later`: that skipped the kit's own add after a long-sleeve upgrade in later mode
    }
    root.classList.toggle('is-sizes-later', later);
    root.querySelectorAll('[data-crew-kit-mode] button[data-mode]').forEach(function (b) {
      var on = b.getAttribute('data-mode') === mode;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    root.querySelectorAll('[data-summary]').forEach(function (i) { i.disabled = later; });
    var flag = root.querySelector('[data-sizes-later-flag]');
    if (flag) flag.disabled = !later;
    if (later) hideError(root);
    syncSleeveUi(root);
    update(root);
  }

  function initModes(root) {
    // one-size single items (caps, beanies) have no sizes to send, so no "send sizes later" line goes on the order
    syncPrint(root); if (root.hasAttribute('data-no-sizes') || !root.hasAttribute('data-sizes-later-ok')) { var modeWrap = root.querySelector('[data-crew-kit-mode]'); if (modeWrap) modeWrap.style.display = 'none'; root.querySelectorAll('[data-crew-kit-later-note]').forEach(function (n) { n.style.display = 'none'; }); setMode(root, 'now'); return; } // Evan 2026-10-28: sizes up front on everything except the Crew Kits (data-sizes-later-ok)
    var wrap = root.querySelector('[data-crew-kit-mode]');
    if (!wrap) return;
    wrap.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('button[data-mode]') : null;
      if (!btn) return;
      e.preventDefault();
      setMode(root, btn.getAttribute('data-mode'));
    });
    // Default to 'later'. Four 6-cell grids is the single biggest block of height above Add To
    // Cart, and the shop confirms sizes on the mockup anyway. The buyer can still switch to 'now'.
    setMode(root, 'later');
  }

  function syncPrint(root) { /* Evan 2026-10-28: first order line says FRONT ONLY or FRONT + BACK with the back-print price, worked out from the variant prices */ var form = root.closest('form'); var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product; var vs = (meta && meta.variants) || []; if (!form || !vs.some(function (v) { return /back/i.test(v.public_title || ''); })) return; var inp = form.querySelector('input[name="properties[Print]"]'); if (!inp) { inp = document.createElement('input'); inp.type = 'hidden'; inp.name = 'properties[Print]'; form.insertBefore(inp, form.firstChild); } function base(v) { return String(v.public_title || '').split(' / ').filter(function (p) { return !/front|back/i.test(p); }).join(' / '); } function set() { var idEl = form.querySelector('[name="id"]'); var v = vs.filter(function (x) { return idEl && String(x.id) === String(idEl.value); })[0]; if (!v) return; if (!/back/i.test(v.public_title || '')) { inp.value = 'FRONT ONLY'; return; } var f = vs.filter(function (x) { return base(x) === base(v) && !/back/i.test(x.public_title || ''); })[0]; var n = parseInt(base(v), 10); var extra = f ? (v.price - f.price) / 100 : 0; inp.value = 'FRONT + BACK' + (extra > 0 ? ' (back print $' + extra + (n ? ' = $' + (extra / n) + ' x ' + n : '') + ')' : ''); } set(); if (!form.__crewPrintWatch) { form.__crewPrintWatch = true; form.addEventListener('change', function () { setTimeout(set, 50); setTimeout(set, 600); }); form.addEventListener('click', function (e) { if (e.target && e.target.closest && e.target.closest('[type="submit"], [name="add"]')) set(); }, true); } } function firstProblem(root) {
    var pickProblem = firstPickProblem(root);
    if (pickProblem) return pickProblem;
    if (root.hasAttribute('data-single') && singleQty(root) < singleMin(root)) return 'The minimum is ' + singleMin(root) + ' pieces. Change how many to ' + singleMin(root) + ' or more.';
    var lsp = lsProblem(root);
    if (lsp) return lsp;
    if (isLater(root)) return '';
    var totals = groupTotals(root);
    var pools = poolTotals(root, totals);
    for (var pk in pools) {
      var pl = pools[pk];
      if (pl.total < pl.count) return 'Shirts: ' + pl.total + ' of ' + pl.count + ' sized' + (pl.groups.length > 1 ? (sleeveCfgOf(root).opts.map(function (o) { return o.key; }).join(',') === 'short,long' ? ' across short and long sleeve' : ' across the sleeve styles') : '') + '. Add ' + (pl.count - pl.total) + ' more.';
      if (pl.total > pl.count) return 'Shirts: ' + pl.total + ' entered, but this kit has ' + pl.count + '. Remove ' + (pl.total - pl.count) + '.';
    }
    for (var i = 0; i < totals.length; i++) {
      var t = totals[i];
      if (t.group.hidden || t.group.getAttribute('data-pool')) continue;
      var label = t.group.querySelector('.crew-kit-group__label').firstChild.textContent;
      if (t.total < t.count) return label + ': ' + t.total + ' of ' + t.count + ' sized. Add ' + (t.count - t.total) + ' more.';
      if (t.total > t.count) {
        if (root.hasAttribute('data-single')) return label + ': ' + t.total + ' entered, but your order is ' + t.count + '. Remove ' + (t.total - t.count) + ' or change how many.';
        var cg = (root.__crewKit || []).filter(function (g) { return g.key === t.group.getAttribute('data-group'); })[0];
        if (cg && cg.countFromVariant) {
          var sumEl = summaryFor(root), maxN = 0;
          if (sumEl) {
            var sd = summaryData(sumEl), oi = sd.options.indexOf(cg.countFromVariant);
            sd.variants.forEach(function (x) { var mm = oi >= 0 && x.options ? String(x.options[oi]).replace(/,/g, '').match(/\d+/) : null; if (mm) maxN = Math.max(maxN, parseInt(mm[0], 10)); });
          }
          return label + ': ' + t.total + ' entered, but you picked ' + t.count + '. Remove ' + (t.total - t.count) + (t.count < maxN ? ' or pick a bigger order above.' : ', or get a custom quote for more than ' + t.count + '.');
        }
        return label + ': ' + t.total + ' entered, but this kit has ' + t.count + '. Remove ' + (t.total - t.count) + '.';
      }
    }
    return '';
  }

  function bigTotal(root) {
    if (isLater(root)) return 0;
    return groupTotals(root).reduce(function (n, t) { return n + t.big; }, 0);
  }

  // Kit order summary above Add To Cart (Evan 2026-09-23, snippets/crew-kit-summary.liquid). Kit price for the chosen
  // fabric variant, shown as the cheapest variant plus one "+$" line per fabric upgrade (each upgrade priced by changing
  // only that option; if the variant prices do not add up option by option it falls back to one line), then the
  // 2XL-and-up pieces entered now at the add-on price, free shipping, and the total. The phone's sticky buy bar shows
  // the same total. Redrawn from update() (size typing, the sizes toggle) and on every variant change.
  function summaryFor(root) {
    var form = root && root.closest ? root.closest('form') : null;
    return form ? form.querySelector('[data-crew-kit-summary]') : null;
  }
  function summaryData(sum) {
    if (!sum.__crewSum) {
      var d = { variants: [], options: [] };
      try { d.variants = JSON.parse(sum.getAttribute('data-variants') || '[]') || []; } catch (e) { d.variants = []; }
      try { d.options = JSON.parse(sum.getAttribute('data-options') || '[]') || []; } catch (e) { d.options = []; }
      d.base = d.variants.slice().sort(function (a, b) { return a.price - b.price; })[0] || null;
      sum.__crewSum = d;
    }
    return sum.__crewSum;
  }
  // Kits whose piece count is a variant option (Evan 2026-09-23, Premium Tee Kit: "allow people to get more than 50
  // shirts"). kit_json marks the garment with countFromVariant: "<option name>", and the option values start with the
  // number ("50", "100"). The size grid, its checks and the order summary all follow the chosen count.
  function selectedVariant(root) {
    var form = root && root.closest ? root.closest('form') : null;
    var sum = summaryFor(root);
    if (!form || !sum) return null;
    var d = summaryData(sum), idInput = form.querySelector('input[name="id"]'), id = idInput ? String(idInput.value) : '';
    for (var i = 0; i < d.variants.length; i++) if (String(d.variants[i].id) === id) return d.variants[i];
    return d.base;
  }
  function variantCount(root, optionName) {
    var sum = summaryFor(root), v = selectedVariant(root), val = null;
    if (sum && v && v.options) {
      var k = summaryData(sum).options.indexOf(optionName);
      if (k >= 0) val = v.options[k];
    }
    if (val == null) val = variantOptionValue(root.closest('form'), optionName);
    var m = val == null ? null : String(val).replace(/,/g, '').match(/\d+/);
    return m ? parseInt(m[0], 10) : 0;
  }
  function applyVariantCounts(root) {
    var moved = false;
    (root.__crewKit || []).forEach(function (g) {
      if (!g.countFromVariant) return;
      var n = variantCount(root, g.countFromVariant);
      if (!(n > 0) || n === g.count) return;
      g.count = n;
      moved = true;
      var grp = root.querySelector('.crew-kit-group[data-group="' + g.key + '"]');
      if (!grp) return;
      grp.setAttribute('data-count', n);
      // a pooled group (Performance Tee Kit: 50 / 75 / 100 shirts in one sleeve style) sizes against the chosen count too
      if (grp.hasAttribute('data-pool') && g.poolCount == null) grp.setAttribute('data-pool-count', n);
      grp.querySelectorAll('input[data-size]').forEach(function (inp) { inp.max = n; });
    });
    var form = root.closest('form');
    if (moved && form) form.__crewKitAddonDone = false;
    return moved;
  }
  function countGarments(root) {
    return (root.__crewKit || []).filter(function (g) { return g.countFromVariant; });
  }
  function variantByOptions(d, opts) {
    for (var i = 0; i < d.variants.length; i++) {
      var v = d.variants[i], same = v.options && v.options.length === opts.length;
      for (var j = 0; same && j < opts.length; j++) if (v.options[j] !== opts[j]) same = false;
      if (same) return v;
    }
    return null;
  }
  function shortMoney(cents) {
    return cents % 100 === 0 ? '$' + (cents / 100).toLocaleString('en-US') : crewMoney(cents);
  }
  // Same wording as the server copy: exact cents when the total divides evenly ("$12.99 a piece"), cents under $20,
  // whole dollars above ("about $21 a piece"), matching the kit photos.
  function perPieceText(total, pieces) {
    if (!(pieces > 0) || !(total > 0)) return '';
    var per = Math.floor(total / pieces);
    if (total % pieces === 0) return crewMoney(per) + ' a piece';
    if (per < 2000) return 'about ' + crewMoney(per) + ' a piece';
    return 'about $' + Math.round(total / pieces / 100).toLocaleString('en-US') + ' a piece';
  }
  function summaryLine(label, amount, extra) {
    var row = document.createElement('div');
    row.className = 'crew-kit-summary__line' + (extra ? ' ' + extra : '');
    var l = document.createElement('span');
    l.className = 'crew-kit-summary__label';
    l.textContent = label;
    var a = document.createElement('span');
    a.className = 'crew-kit-summary__amt' + (amount === 'Free' ? ' crew-kit-summary__amt--free' : '');
    a.textContent = amount;
    row.appendChild(l);
    row.appendChild(a);
    return row;
  }
  function renderSummary(root) {
    if (!root || root.hasAttribute('data-single')) return;
    var sum = summaryFor(root);
    if (!sum) return;
    var form = root.closest('form');
    var d = summaryData(sum);
    var idInput = form.querySelector('input[name="id"]');
    var id = idInput ? String(idInput.value) : '';
    var v = null;
    d.variants.forEach(function (x) { if (String(x.id) === id) v = x; });
    v = v || d.base;
    if (!v) return;
    var title = sum.getAttribute('data-title') || '';
    // Count kits: the base is the cheapest variant with the SAME count, so "100 shirts" is the line, not a "+$" upgrade.
    var counted = countGarments(root), countIdx = {};
    counted.forEach(function (g) { var k = d.options.indexOf(g.countFromVariant); if (k >= 0) countIdx[k] = g; });
    var countKeys = Object.keys(countIdx);
    var base = d.base;
    if (countKeys.length && v.options) {
      base = d.variants.filter(function (x) {
        return x.options && countKeys.every(function (k) { return x.options[k] === v.options[k]; });
      }).sort(function (a, b) { return a.price - b.price; })[0] || v;
      title += countKeys.map(function (k) {
        var n = String(v.options[k]).replace(/,/g, '').match(/\d+/);
        return ' \u00b7 ' + (n ? n[0] : v.options[k]) + ' ' + (countIdx[k].countUnit || String(countIdx[k].label || 'pieces').toLowerCase());
      }).join('');
    }
    if (document.body.hasAttribute('data-crew-one-price') && v.options) { v.options.forEach(function (o, i) { if (!countIdx[i]) title += ' \u00b7 ' + o; }); base = v; }
    // Fabric upgrades against the cheapest variant, labelled with the kit's own garment names ("Hoodies: Cotton fleece").
    var ups = [];
    if (base && base.id !== v.id && v.options && base.options && v.options.length === base.options.length) {
      var added = 0;
      for (var k = 0; k < v.options.length && ups; k++) {
        if (v.options[k] === base.options[k]) continue;
        var probe = base.options.slice();
        probe[k] = v.options[k];
        var pv = variantByOptions(d, probe);
        if (!pv) { ups = null; break; }
        var name = d.options[k] || '';
        var nm = null;
        (root.__crewKit || []).forEach(function (g) { if (nm) return; if (g.dependsOnVariant === d.options[k] && g.label) nm = g.pool ? 'Shirts' : g.label; });
        if (nm) name = nm;
        ups.push({ label: (name ? name + ': ' : '') + v.options[k], delta: pv.price - base.price });
        added += pv.price - base.price;
      }
      if (ups && base.price + added !== v.price) ups = null;
    }
    var lines = sum.querySelector('[data-crew-kit-summary-lines]');
    var frag = document.createDocumentFragment();
    if (ups) {
      frag.appendChild(summaryLine(title, crewMoney(base.price)));
      ups.forEach(function (u) { frag.appendChild(summaryLine(u.label, '+' + crewMoney(u.delta), 'crew-kit-summary__line--sub')); });
    } else {
      var rest = (v.options || []).filter(function (o, k) { return !countIdx[k]; });
      frag.appendChild(summaryLine(title + (rest.length && v.id !== (base && base.id) ? ' · ' + rest.join(' / ') : ''), crewMoney(v.price)));
    }
    var addon = parseInt(sum.getAttribute('data-addon-cents'), 10) || 300;
    var big = bigTotal(root);
    if (big > 0) frag.appendChild(summaryLine('2XL and up, ' + big + ' \u00d7 ' + shortMoney(addon), '+' + crewMoney(big * addon)));
    var ls = lsTotal(root), lsUnit = lsUnitCents(form);
    if (ls > 0) frag.appendChild(summaryLine('Long sleeve, ' + ls + ' \u00d7 ' + shortMoney(lsUnit), '+' + crewMoney(ls * lsUnit)));
    // Hoodie Kit (2026-10-21): shipping is charged on template product.hoodie. The server sets data-shipping on the
    // summary (snippets/crew-kit-summary.liquid) and the hoodie template marks body data-crew-shipping=checkout.
    var shipText = sum.getAttribute('data-shipping') || ((document.body && document.body.getAttribute('data-crew-shipping') === 'checkout') ? 'Added at checkout' : 'Calculated at checkout');
    frag.appendChild(summaryLine('Shipping', shipText));
    if (lines) { lines.innerHTML = ''; lines.appendChild(frag); }
    var total = v.price + big * addon + ls * lsUnit;
    var totalEl = sum.querySelector('[data-crew-kit-summary-total]');
    if (totalEl && totalEl.textContent !== crewMoney(total)) totalEl.textContent = crewMoney(total);
    var pieces = parseInt(sum.getAttribute('data-pieces'), 10) || (function () { var seenPool = {}; return (root.__crewKit || []).reduce(function (n, g) {
      if (g.pool) { if (seenPool[g.pool]) return n; seenPool[g.pool] = true; return n + (parseInt(g.poolCount != null ? g.poolCount : (g.baseCount != null ? g.baseCount : g.count), 10) || 0); }   // base count; the chosen count's extra is added below, once per pool
      return n + (parseInt(g.baseCount != null ? g.baseCount : g.count, 10) || 0); }, 0); })();
    // data-pieces is the base (cheapest) count; add what the chosen count option adds on top
    var seenCountPool = {};
    pieces += counted.reduce(function (n, g) {
      if (g.pool) { if (seenCountPool[g.pool]) return n; seenCountPool[g.pool] = true; }   // one sleeve style per pool
      return n + ((parseInt(g.count, 10) || 0) - (parseInt(g.baseCount, 10) || 0)); }, 0);
    var note = sum.querySelector('[data-crew-kit-summary-note]');
    if (note) note.textContent = (counted[0] && counted[0].countUnit === 'people' ? ((parseInt(counted[0].count, 10) || 0) > 0 ? counted[0].count + ' people, ' + perPieceText(total, parseInt(counted[0].count, 10)).replace(' a piece', ' a person') + '. ' : '') : (pieces > 0 ? pieces + ' pieces, ' + perPieceText(total, pieces) + '. ' : '')) + (shipText === 'Free' ? 'Tax calculated at checkout.' : 'Shipping and tax calculated at checkout.');
    var later = sum.querySelector('[data-crew-kit-summary-later]');
    if (later) {
      later.hidden = !(isLater(root) && root.querySelector('.crew-kit-group'));
      later.textContent = '2XL and up add ' + shortMoney(addon) + ' a piece, billed once you send sizes.';
    }
    form.querySelectorAll('[data-crew-sticky-price]').forEach(function (el) { el.textContent = crewMoney(total); });
  }

  var addonVariant = null, addonLoading = null;
  function loadAddon(handle) {
    if (addonVariant) return Promise.resolve(addonVariant);
    if (addonLoading) return addonLoading;
    addonLoading = fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { addonVariant = p && p.variants && p.variants[0] ? p.variants[0].id : null; return addonVariant; })
      .catch(function () { return null; });
    return addonLoading;
  }

  function ensureAddon(root, form) {
    var big = isLater(root) ? 0 : bigTotal(root), ls = lsTotal(root), spots = spotAddonQty(root, form);
    if ((big <= 0 && ls <= 0 && spots <= 0) || form.__crewKitAddonDone) return Promise.resolve();
    form.__crewKitAddonDone = true; // latch before any await, so a double tap cannot add it twice
    var handle = root.getAttribute('data-addon-handle');
    var forName = (summaryFor(root) && summaryFor(root).getAttribute('data-title')) || document.title.split(' – ')[0];
    return Promise.all([big > 0 ? loadAddon(handle) : Promise.resolve(null), ls > 0 ? loadLsAddon() : Promise.resolve(null)]).then(function (res) {
      var items = [];
      if (big > 0 && res[0]) items.push({ id: res[0], quantity: big, properties: { 'For': forName } });
      if (ls > 0) { var lv = lsAddonVariantId(form, res[1]); if (lv) items.push({ id: lv, quantity: ls, properties: { 'For': forName } }); }
      if (spots > 0) { var sl = form.querySelector('[data-crew-spot-link]'); items.push({ id: SPOT_ADDON_VARIANT, quantity: spots, properties: { 'For': forName, '_crew_spot_link': sl ? sl.value : '' } }); }
      if (!items.length) return;
      return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items }) })
        .then(function () {}, function () { form.__crewKitAddonDone = false; });
    }, function () { form.__crewKitAddonDone = false; });
  }

  // The size toggle is locked while the add-on request is in flight, so the mode cannot change mid-add.
  function lockModes(root, on) {
    root.querySelectorAll('[data-crew-kit-mode] button[data-mode], [data-crew-kit-sleeves] button[data-sleeves]').forEach(function (b) { b.disabled = !!on; });
    var vs = variantSelectsFor(root);
    if (vs) { vs.style.pointerEvents = on ? 'none' : ''; if (on) vs.setAttribute('aria-busy', 'true'); else vs.removeAttribute('aria-busy'); }
  }

  // Order lines: on a press that gets through, write ONE cart property per garment, e.g.
  // "Hoodie: Independent Trading Co. SS4500 / Forest Green / M 4 (4 total)", in place of the
  // separate "Hoodie color" and "Hooded sweatshirts sizes" lines, so the Shopify order shows
  // brand + model, colour and sizes together. The old fields lose their name only for this
  // press: Globo sends its own request, so they stay off for 20 s or until the next press.
  function gate(e, form, root, resubmit) {
    gate0(e, form, root, resubmit);
    if (!e.defaultPrevented) orderLines(form, root);
  }
  function restoreOrderLines(form) {
    form.querySelectorAll('[data-crew-name]').forEach(function (el) { el.name = el.getAttribute('data-crew-name'); el.removeAttribute('data-crew-name'); });
    form.querySelectorAll('[data-crew-line]').forEach(function (n) { n.remove(); });
  }
  function orderLines(form, root) {
    try {
      var kit = root.__crewKit || [];
      if (!kit.length) return;
      restoreOrderLines(form);
      var get = function (n) {
        var els = form.querySelectorAll('[name="properties[' + n.replace(/"/g, '\\"') + ']"]');
        for (var i = 0; i < els.length; i++) if (!els[i].disabled) return els[i];
        return null;
      };
      var later = isLater(root), lines = [], used = [];
      kit.forEach(function (g) {
        if (g.count === 0) return;
        var cn = g.color || g.label.replace(/s$/, '') + ' color';
        var c = get(cn), s = get(g.label + ' sizes');
        var parts = [[g.brand, g.model].filter(Boolean).join(' ')];
        if (c && c.value) parts.push(c.value);
        if (g.sized === false) parts.push(g.count + ' pcs');
        else if (s && s.value) parts.push(s.value);
        else if (later) parts.push('sizes to come');
        lines.push([cn.replace(/ colou?r$/i, ''), parts.filter(Boolean).join(' / ')]);
        if (c) used.push(c);
        if (s) used.push(s);
      });
      if (!lines.length) return;
      var print = form.querySelector('input[name="properties[Print]"]');
      var ref = print ? print.nextSibling : form.firstChild;
      lines.forEach(function (l) {
        var i = document.createElement('input');
        i.type = 'hidden'; i.name = 'properties[' + l[0] + ']'; i.value = l[1];
        i.setAttribute('data-crew-line', '');
        form.insertBefore(i, ref);
      });
      used.forEach(function (el) { el.setAttribute('data-crew-name', el.name); el.removeAttribute('name'); });
      setTimeout(function () { restoreOrderLines(form); }, 20000);
    } catch (err) { window.console && console.warn('crew order lines', err); }
  }

  // Runs BEFORE Globo Product Options (which submits the form with its own request) and before Dawn's form handler.
  function gate0(e, form, root, resubmit) {
    if (form.__crewKitPass) { form.__crewKitPass = false; return; }
    // Globo's fields are not on the page, so the theme's own logo field must be showing and filled.
    // Without this a kit went to the cart with no logo or colors whenever Globo failed to load.
    if (!globoReady(form)) {
      var missing = checkFallback(root, true);
      if (missing) { e.preventDefault(); e.stopImmediatePropagation(); showFallbackError(form, missing); crewTrack('cr_atc_blocked', 'crew_block', missing.msg === LOGO_MSG ? 'logo' : 'logo_big'); return; }
      hideFallbackError(form);
    } else {
      // Globo's required fields (the logo on every Globo kit, the Hi-Vis colors). The theme's message and scroll
      // replace Globo's small "This field is required" under the header. Presence reads the same signals Globo's
      // check does plus its upload card, so this never stops a press Globo itself would let through.
      var need = globoMissing(form);
      if (need) {
        e.preventDefault(); e.stopImmediatePropagation();
        showGloboNeed(form, need, true);
        crewTrack('cr_atc_blocked', 'crew_block', need.querySelector('input[type="file"]') ? 'logo' : 'option');
        return;
      }
    }
    var problem = firstProblem(root);
    if (problem) { e.preventDefault(); e.stopImmediatePropagation(); showError(root, problem); crewTrack('cr_atc_blocked', 'crew_block', 'sizes'); return; }
    if (((isLater(root) ? 0 : bigTotal(root)) > 0 || lsTotal(root) > 0 || spotAddonQty(root, form) > 0) && !form.__crewKitAddonDone) {
      // Globo checks its required fields only on a real press. Holding this press for the $3 add-on and
      // resubmitting afterwards would skip that check, so while Globo's logo is still empty the press goes
      // straight on to Globo, which shows its own errors and stops the add. A company name never holds it here.
      if (globoReady(form) && globoMissing(form)) return;
      e.preventDefault(); e.stopImmediatePropagation();
      lockModes(root, true);
      ensureAddon(root, form).then(function () {
        lockModes(root, false);
        if (form.__crewKitCancelAddon) { form.__crewKitCancelAddon = false; return; }
        form.__crewKitPass = true;
        resubmit();   // the kit line itself (Globo / Dawn add) always follows the add-on lines
      });
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('button[name="add"], .product-form__submit') : null;
    if (!btn) return;
    var form = btn.closest('form');
    var root = form ? form.querySelector('[data-crew-kit-sizes]') : null;
    if (!root) return;
    gate(e, form, root, function () { btn.click(); });
  }, true);

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || t.type !== 'file' || !t.form || !t.form.querySelector('[data-crew-kit-sizes]')) return;
    var inGlobo = !!(t.closest && t.closest('.gpo-container'));
    if (t.files && t.files.length) crewTrack('cr_logo_picked', 'crew_logo', inGlobo ? 'globo' : 'theme');
    if (inGlobo) { var f = t.form; setTimeout(function () { syncGloboNeed(f); }, 0); }
  }, true);

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement) || form.getAttribute('data-type') !== 'add-to-cart-form') return;
    var root = form.querySelector('[data-crew-kit-sizes]');
    if (!root) return;
    gate(e, form, root, function () { form.requestSubmit ? form.requestSubmit() : form.submit(); });
  }, true);

  // Globo Product Options injects its fields at runtime (before the add-to-cart button). Keep the
  // order logo -> colors -> sizes by moving the size grid directly after Globo's container once it exists.
  function placeAfterGlobo(root) {
    var form = root.closest('form');
    var block = root.closest('[data-crew-kit-config]') || root;
    var gpo = form ? form.querySelector('.gpo-container') : null;
    if (gpo && gpo.nextElementSibling !== block) gpo.insertAdjacentElement('afterend', block);
  }

  // Read the currently chosen value of a Shopify variant OPTION (Dawn's <variant-selects>), matched by the
  // option's own name. Handles both the dropdown and the radio/swatch renderings. Used so a colour list can follow
  // a variant choice (fabric) instead of a sibling pick field.
  function variantSelectsFor(node) {
    // Dawn renders <variant-selects> as its own section block, OUTSIDE the product form, so scoping the
    // lookup to the form finds nothing (caught 2026-09-17: colours silently stayed on the default fabric).
    var scope = node && node.closest ? node.closest('[id^="shopify-section"]') : null;
    return (scope && scope.querySelector('variant-selects')) || document.querySelector('variant-selects');
  }
  function variantOptionGroup(form, optionName) {
    var vs = variantSelectsFor(form);
    if (!vs) return null;
    function norm(t) { return String(t || '').replace(/[:\s]+$/, '').trim().toLowerCase(); }
    var want = norm(optionName), hit = null;
    vs.querySelectorAll('.product-form__input').forEach(function (grp) {
      if (hit) return;
      var lab = grp.querySelector('legend.form__label, label.form__label');
      if (!lab) return;
      var first = lab.childNodes[0] && lab.childNodes[0].nodeValue;
      if (norm(first || lab.textContent) === want) hit = grp;
    });
    return hit;
  }
  function variantOptionValue(form, optionName) {
    var grp = variantOptionGroup(form, optionName);
    if (!grp) return null;
    var sel = grp.querySelector('select');
    if (sel) return sel.value;
    var r = grp.querySelector('input:checked');
    return r ? r.value : null;
  }

  // Color / cap-style pickers (line item properties). A field with dependsOn rebuilds its list from valuesBy[parent value].
  function buildPicks(picks) {
    var cfg;
    try { cfg = JSON.parse(picks.getAttribute('data-picks') || '{}'); } catch (e) { return; }
    var wrap = picks.querySelector('[data-crew-kit-pick-fields]');
    if (!wrap || !cfg.fields) return;
    wrap.innerHTML = '';
    var selects = {};
    function fill(sel, values, chosen) {
      sel.innerHTML = '';
      values.forEach(function (v) {
        var o = document.createElement('option');
        o.value = v; o.textContent = v;
        if (v === chosen) o.selected = true;
        sel.appendChild(o);
      });
    }
    cfg.fields.forEach(function (f) {
      var field = document.createElement('label');
      field.className = 'crew-kit-pick';
      field.innerHTML = '<span class="crew-kit-pick__label">' + f.label + (f.note ? '<small>' + f.note + '</small>' : '') + '</span>';
      var pickStyle = styleWithDeco(f);
      if (pickStyle) field.querySelector('.crew-kit-pick__label').appendChild(pickStyle);
      addChartButton(field.querySelector('.crew-kit-pick__label'), f);
      if (f.type === 'text') {
        var inp = document.createElement('input');
        inp.type = 'text';
        inp.name = 'properties[' + f.label + ']';
        inp.setAttribute('data-pick', f.key);
        inp.placeholder = f.placeholder || '';
        inp.autocomplete = 'off';
        if (f.required) inp.setAttribute('data-required', '1');
        field.appendChild(inp);
        field.classList.add('crew-kit-pick--wide');
        wrap.appendChild(field);
        return;
      }
      var sel = document.createElement('select');
      sel.name = 'properties[' + f.label + ']';
      sel.setAttribute('data-pick', f.key);
      sel.required = true;
      var values = f.values
        || (f.dependsOnVariant && f.valuesBy
              ? (f.valuesBy[variantOptionValue(picks.closest('form'), f.dependsOnVariant)] || f.valuesBy[f.variantDefault] || [])
              : null)
        || (f.dependsOn && f.valuesBy ? f.valuesBy[cfg.fields.filter(function (p) { return p.key === f.dependsOn; })[0].default] : [])
        || [];
      fill(sel, values, f.default);
      field.appendChild(sel);
      wrap.appendChild(field);
      selects[f.key] = sel;
    });
    cfg.fields.forEach(function (f) {
      if (!f.dependsOn || !f.valuesBy) return;
      var parent = selects[f.dependsOn], child = selects[f.key];
      if (!parent || !child) return;
      parent.addEventListener('change', function () {
        var values = f.valuesBy[parent.value] || [];
        var keep = values.indexOf(child.value) >= 0 ? child.value : f.default;
        fill(child, values, keep);
      });
    });

    // Variant-driven lists: the fabric lives in Shopify's own variant picker (so Shopify prices it), and the
    // matching colour run has to follow it. Dawn re-renders its picker on change, so re-read on every form change.
    var form = picks.closest('form');
    var vdeps = cfg.fields.filter(function (f) { return f.dependsOnVariant && f.valuesBy; });
    if (vdeps.length) {
      // Garment decisions belong together: fabric, then colour, then sizes. Dawn puts its picker up by the price,
      // stranded above the logo fields, so move it down to sit right on top of this block.
      var vsel = variantSelectsFor(picks);
      if (vsel && vsel.parentNode !== picks.parentNode) {
        var card = document.createElement('div');
        card.className = 'crew-kit-fabric';
        card.setAttribute('data-crew-kit-fabric', '');
        // pick_json may name this card itself (Hat Kit 24: "Pick your hat"); the fabric kits keep the old words.
        var h = document.createElement('h3');
        h.className = 'crew-kit-sizes__title';
        h.textContent = cfg.variantHeading || 'Fabric';
        var sub = document.createElement('p');
        sub.className = 'crew-kit-sizes__intro';
        sub.textContent = cfg.variantIntro || 'Performance wicks and dries fast. The cotton side is thicker and broken-in. Pick one for each piece - the price updates as you go.';
        card.appendChild(h); card.appendChild(sub);
        picks.parentNode.insertBefore(card, picks);
        card.appendChild(vsel);
      }
    }
    if (vdeps.length) {
      var applyVariant = function () {
        vdeps.forEach(function (f) {
          var child = selects[f.key];
          if (!child) return;
          var v = variantOptionValue(form, f.dependsOnVariant);
          var values = f.valuesBy[v] || f.valuesBy[f.variantDefault] || [];
          if (!values.length) return;
          var keep = values.indexOf(child.value) >= 0 ? child.value : f.default;
          if (child.options.length === values.length && child.value === keep) return;
          fill(child, values, keep);
        });
        applyFabricNames(form);
      };
      picks.__applyVariant = applyVariant;
      // the pick fields are not in the DOM yet on this tick, so paint the garment names just after
      setTimeout(applyVariant, 0);
      var watchOn = document.querySelector('.product__info-container') || document;
      if (!watchOn.__crewKitVariantWatch) {
        watchOn.__crewKitVariantWatch = true;
        watchOn.addEventListener('change', function (e) {
          if (!e.target || !e.target.closest || !e.target.closest('variant-selects')) return;
          setTimeout(function () {
            document.querySelectorAll('[data-crew-kit-picks]').forEach(function (p) {
              if (p.__applyVariant) p.__applyVariant();
            });
          }, 60);
        });
      }
      applyVariant();
    }
  }
  // Comfy Kit "How your logo goes on" card (snippets/crew-kit-logo.liquid). The hoodie choice is a plain radio pair that
  // posts as properties[Hoodie logo] by itself; this only keeps the decoration pill under the hoodie color dropdown in
  // step with it ("Printed front + back" / "Embroidered front"), so the two never disagree on screen.
  function initLogoChoice(scope) {
    scope.querySelectorAll('[data-crew-kit-logo]').forEach(function (card) {
      var form = card.closest('form') || document;
      function sync() {
        card.querySelectorAll('input[data-deco-for]:checked').forEach(function (r) {
          var sel = form.querySelector('select[data-pick="' + r.getAttribute('data-deco-for') + '"]');
          var field = sel && sel.closest('.crew-kit-pick');
          var pill = field && field.querySelector('.crew-kit-style__deco');
          if (!pill) return;
          var text = r.getAttribute('data-deco') || r.value;
          pill.textContent = text;
          pill.classList.toggle('crew-kit-style__deco--emb', /^embroider/i.test(text));
        });
      }
      if (!card.__crewKitLogo) { card.__crewKitLogo = true; card.addEventListener('change', sync); }
      sync();
    });
  }

  // Globo's color dropdowns ("Tees color", "Cap color" ...) get the garment's brand/name/model line under the label.
  // Matched on the label text against each garment's "color" key; display only, the cart property names don't change.
    // Globo owns the colour picker labels and the theme owns the kit JSON, so the two can drift
  // (Globo can say "Tees color" while the kit says "T-Shirt color"). Match on a normalised form so
  // tee / tees / t-shirt / short sleeve tee all line up, and a rename on either side keeps the style
  // pill and the one-colour picker working.
  function normLabel(s) {
    return String(s == null ? '' : s)
      .toLowerCase()
      .replace(/t\s*-\s*shirts?|tshirts?/g, 'tee')
      .replace(/\bshort\s+sleeve[sd]?\b/g, '')
      .replace(/tees\b/g, 'tee')
      .replace(/[^a-z0-9]+/g, '');
  }

  // A kit piece can be a different garment in each fabric (heavyweight cotton hooded tees are an
  // Independent hoodie, not a hooded tee), so the brand and model shown have to follow the fabric
  // the buyer picked - on the size group heading and on the colour picker.
  function applyFabricNames(form) {
    if (!form) return;
    var rootEl = form.querySelector('[data-kit]');
    var kit = rootEl && rootEl.__crewKit;
    if (!kit || !kit.length) return;
    kit.forEach(function (g) {
      if (!g.dependsOnVariant || !g.byFabric) return;
      var spec = g.byFabric[variantOptionValue(form, g.dependsOnVariant)];
      if (!spec) return;
      g.brand = spec.brand; g.name = spec.name; g.model = spec.model;
      var head = form.querySelector('.crew-kit-group[data-group="' + g.key + '"] .crew-kit-group__title');
      if (head) {
        var oldPill = head.querySelector('.crew-kit-style');
        if (oldPill) oldPill.parentNode.removeChild(oldPill);
        var pill = styleEl(g);
        if (pill) head.appendChild(pill);
      }
      form.querySelectorAll('.crew-kit-pick__label').forEach(function (l) {
        var t = l.firstChild && l.firstChild.nodeType === 3 ? l.firstChild.textContent : l.textContent;
        if (normLabel(t) !== normLabel(g.color)) return;
        // Evan 2026-09-17: rescue the "?" button before the old pill is torn out. The chart button lives
        // inside .crew-kit-style, so removing the pill took it with it and it never came back once a
        // customer touched a fabric toggle. removeChild only detaches, so the node is still good to reuse.
        var savedBtn = l.querySelector('.crew-chart-btn');
        l.querySelectorAll('.crew-kit-style, :scope > .crew-kit-style__deco').forEach(function (o) {
          o.parentNode.removeChild(o);
        });
        var p = styleWithDeco(g);
        if (p) { l.appendChild(p); var btn2 = savedBtn || l.querySelector('.crew-chart-btn'); if (btn2) p.appendChild(btn2); }
      });
    });
  }

  // "?" beside a colour picker opens that garment's colour chart. The chart follows the fabric choice, so a
  // heavyweight cotton t-shirt opens the Comfort Colors sheet and a performance one opens the A4 sheet.
  function chartFor(f, form) {
    if (f.chartsBy && f.dependsOnVariant && form) {
      var v = variantOptionValue(form, f.dependsOnVariant);
      return f.chartsBy[v] || f.chartsBy[f.variantDefault] || null;
    }
    return f.chart || null;
  }
  var chartModal = null;
  function closeChart() {
    if (chartModal) chartModal.hidden = true;
    document.documentElement.classList.remove('crew-chart-open');
  }
  function openChart(url, title) {
    if (!chartModal) {
      chartModal = document.createElement('div');
      chartModal.className = 'crew-chart';
      chartModal.hidden = true;
      chartModal.innerHTML = '<div class="crew-chart__backdrop" data-close></div>' +
        '<div class="crew-chart__box" role="dialog" aria-modal="true">' +
        '<button type="button" class="crew-chart__close" data-close aria-label="Close">&#215;</button>' +
        '<p class="crew-chart__title"></p><img class="crew-chart__img" alt=""></div>';
      document.body.appendChild(chartModal);
      chartModal.addEventListener('click', function (e) { if (e.target.hasAttribute('data-close')) closeChart(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeChart(); });
    }
    chartModal.querySelector('.crew-chart__title').textContent = title || '';
    var img = chartModal.querySelector('.crew-chart__img');
    img.src = url; img.alt = title || 'Colour chart';
    chartModal.hidden = false;
    document.documentElement.classList.add('crew-chart-open');
  }
  function addChartButton(labelEl, f) {
    if (!labelEl || (!f.chart && !f.chartsBy)) return;
    var nice = String(f.label || '').replace(/\s*colou?r$/i, '');
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'crew-chart-btn';
    b.textContent = '?';
    b.setAttribute('aria-label', 'See every ' + nice + ' color');
    b.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      var url = chartFor(f, b.closest('form'));
      if (url) openChart(url, nice + ' colors');
    });
    // the "?" rides at the end of the garment line, after the PRINTED / EMBROIDERED tag
    (labelEl.querySelector('.crew-kit-style') || labelEl).appendChild(b);
  }

  function annotateGlobo(root) {
    var kit = root.__crewKit || [];
    var form = root.closest('form');
    if (!form || !kit.length) return;
    var byColor = {};
    kit.forEach(function (g) { if (g.color && g.brand) byColor[normLabel(g.color)] = g; });
    form.querySelectorAll('.gpo-container label.gpo-label').forEach(function (label) {
      if (label.querySelector('.crew-kit-style')) return;
      var text = normLabel((label.querySelector('.label-content') || label).textContent);
      var g = byColor[text];
      var gs = g && styleWithDeco(g, 'crew-kit-style--globo');
      if (gs) label.appendChild(gs);
    });
  }

  // One kit color instead of a dropdown per garment. Each family names the matching color for every
  // garment model. A family only shows on a kit when each of that kit's Globo color dropdowns offers its
  // mapped color, so a model swap or a color removed in Globo hides the family instead of ordering a
  // shade that does not exist. The dropdowns stay Globo's own (same cart properties), collapsed behind
  // "Customize each piece"; Globo builds the order from its hidden inputs, which follow its radios.
  var KIT_COLORS = [
    { name: 'Black', hex: '#1c1c1e', models: { N3142: 'Black', N3165: 'Black', PC380H: 'Jet Black', K110: 'Deep Black', '112': 'Black', SS4500: 'Black', '6014': 'Black', '1717': 'Black', CP90: 'Black' } },
    { name: 'Charcoal', hex: '#55585d', models: { N3142: 'Graphite', N3165: 'Graphite', PC380H: 'Charcoal', K110: 'Graphite', '112': 'Charcoal/Black', SS4500: 'Charcoal', '6014': 'Graphite', '1717': 'Graphite', CP90: 'Charcoal Heather' } },
    { name: 'Grey', hex: '#b8bcc2', models: { N3142: 'Silver', N3165: 'Silver', PC380H: 'Silver', K110: 'Gusty Grey', '112': 'Heather Grey/Black', SS4500: 'Grey Heather', '6014': 'Grey', '1717': 'Grey', CP90: 'Athletic Oxford' } },
    { name: 'White', hex: '#ffffff', models: { N3142: 'White', N3165: 'White', PC380H: 'White', K110: 'White', '112': 'White', SS4500: 'White', '6014': 'White', '1717': 'White', CP90: 'White' } },
    { name: 'Navy', hex: '#1d2a47', models: { N3142: 'Navy', N3165: 'Navy', PC380H: 'True Navy', K110: 'River Blue Navy', '112': 'Navy', SS4500: 'Classic Navy', '6014': 'True Navy', '1717': 'True Navy', CP90: 'Navy' } },
    { name: 'Royal', hex: '#1f4fa6', models: { N3142: 'Royal', N3165: 'Royal', PC380H: 'True Royal', K110: 'True Royal', '112': 'Royal/White' } },
    { name: 'Red', hex: '#c9262f', models: { N3142: 'Scarlet', N3165: 'Scarlet', PC380H: 'Red', K110: 'Rich Red', '112': 'Red/White', SS4500: 'Red', '6014': 'Red', '1717': 'Red', CP90: 'Athletic Red' } },
    { name: 'Sand', hex: '#cdbba0', models: { SS4500: 'Sandstone', '6014': 'Sandstone', '1717': 'Sandstone', CP90: 'Coyote Brown' } },
    { name: 'Forest Green', hex: '#1f4d2e', models: { N3142: 'Forest', N3165: 'Forest', K110: 'Deep Forest Green', '112': 'Dark Green/White', SS4500: 'Forest Green', '6014': 'Blue Spruce', '1717': 'Blue Spruce', CP90: 'Athletic Green' } },
    { name: 'Kelly Green', hex: '#2b8a3e', models: { N3142: 'Kelly', N3165: 'Kelly', K110: 'Bright Kelly Green', '112': 'Kelly/White', SS4500: 'Kelly Green', '6014': 'Island Green', '1717': 'Island Green', CP90: 'Athletic Green' } },
    { name: 'Safety Yellow', hex: '#dcef1f', models: { CS401: 'Safety Yellow', CSV405: 'Safety Yellow' } },
    { name: 'Safety Orange', hex: '#ff6b1f', models: { CS401: 'Safety Orange', CSV405: 'Safety Orange' } }
  ];

  function kitPieces(root) {
    var kit = root.__crewKit || [];
    var form = root.closest('form');
    var byColor = {}, out = [];
    kit.forEach(function (g) { if (g.color && g.model) byColor[normLabel(g.color)] = g; });
    if (!form) return out;
    form.querySelectorAll('.gpo-container .gpo-element').forEach(function (el) {
      var label = el.querySelector('label.gpo-label');
      var radios = el.querySelectorAll('input[type="radio"]');
      var g = label && byColor[normLabel((label.querySelector('.label-content') || label).textContent)];
      if (g && radios.length) out.push({ el: el, garment: g, radios: radios });
    });
    // the theme's own color pickers (pick_json selects, e.g. the Comfy Kit's full stock color runs) are pieces as well
    form.querySelectorAll('[data-crew-kit-picks] select[data-pick]').forEach(function (sel) {
      var field = sel.closest('.crew-kit-pick');
      var labelEl = field && field.querySelector('.crew-kit-pick__label');
      var text = labelEl ? (labelEl.firstChild && labelEl.firstChild.nodeType === 3 ? labelEl.firstChild.textContent : labelEl.textContent) : '';
      var g = byColor[normLabel(text)];
      if (g && field) out.push({ el: field, garment: g, radios: [], select: sel });
    });
    return out;
  }
  function pieceValue(p) {
    if (p.select) return p.select.value;
    for (var i = 0; i < p.radios.length; i++) { if (p.radios[i].checked) return p.radios[i].value; }
    return '';
  }
  // the control that selects `value` on this piece: a Globo radio, or an <option> of the theme's select
  function pieceRadio(p, value) {
    if (p.select) {
      for (var j = 0; j < p.select.options.length; j++) { if (p.select.options[j].value === value && !p.select.options[j].disabled) return p.select.options[j]; }
      return null;
    }
    for (var i = 0; i < p.radios.length; i++) { if (p.radios[i].value === value && !p.radios[i].disabled) return p.radios[i]; }
    return null;
  }
  function pieceSet(p, r) {
    if (p.select) {
      if (p.select.value === r.value) return;
      p.select.value = r.value;
      p.select.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    if (r.checked) return;
    r.checked = true;
    r.dispatchEvent(new Event('input', { bubbles: true }));
    r.dispatchEvent(new Event('change', { bubbles: true }));
  }
  function kitFamilyNow(st) {
    for (var i = 0; i < st.fams.length; i++) {
      var f = st.fams[i];
      if (st.pieces.every(function (p) { return pieceValue(p) === f.models[p.garment.model]; })) return f;
    }
    return null;
  }
  function isLightHex(hex) {
    var n = parseInt(hex.slice(1), 16);
    return (((n >> 16) & 255) * 299 + ((n >> 8) & 255) * 587 + (n & 255) * 114) / 1000 > 150;
  }
  // "Tees, long sleeves, hooded tees and polos in Red. Caps in Red/White." A two-tone cap gets its own sentence.
  function kitColorSummary(st, f) {
    var solid = [], out = [];
    st.pieces.forEach(function (p) {
      var v = f.models[p.garment.model];
      if (v.indexOf('/') >= 0) out.push(p.garment.label + ' in ' + v + '.');
      else solid.push(solid.length ? p.garment.label.toLowerCase() : p.garment.label);
    });
    if (solid.length) out.unshift((solid.length < 2 ? solid[0] : solid.slice(0, -1).join(', ') + ' and ' + solid[solid.length - 1]) + ' in ' + f.name + '.');
    return out.join(' ');
  }

  function syncKitColor(root) {
    var st = root.__kitColor;
    if (!st || st.applying) return;
    var f = kitFamilyNow(st);
    st.inputs.forEach(function (inp) { inp.checked = !!f && inp.value === f.name; });
    st.name.textContent = f ? f.name : 'Mixed';
    st.summary.textContent = f ? kitColorSummary(st, f) : 'Pieces have different colors. Pick one above to match them all.';
  }

  function setPiecesOpen(root, open) {
    var st = root.__kitColor;
    st.open = !!open;
    st.toggle.setAttribute('aria-expanded', st.open ? 'true' : 'false');
    // The Mix tile sits in the swatch row and toggles the same panel, so it has to
    // track the same state (Evan 2026-09-17: buyers were not seeing the text link).
    if (st.mix) {
      st.mix.setAttribute('aria-expanded', st.open ? 'true' : 'false');
      st.mix.classList.toggle('is-on', st.open);
    }
    st.pieces.forEach(function (p) { p.el.classList.toggle('crew-kit-piece--hidden', !st.open); });
  }

  // How many distinct colors sit behind the panel, so the label can say a number
  // instead of "more". Counts each piece's own options and de-duplicates by name.
  function kitColorChoiceCount(pieces) {
    var seen = {};
    pieces.forEach(function (p) {
      var opts = p.select ? p.select.options : p.radios;
      for (var i = 0; i < opts.length; i++) {
        var o = opts[i];
        if (o && o.value && !o.disabled) seen[String(o.value).toLowerCase()] = 1;
      }
    });
    return Object.keys(seen).length;
  }

  var kitColorSeq = 0;
  function initKitColor(root) {
    var old = root.__kitColor;
    if (old && old.box.isConnected && old.pieces.every(function (p) { return p.el.isConnected; })) return;
    var pieces = kitPieces(root);
    if (pieces.length < 2) return;
    var fams = KIT_COLORS.filter(function (f) {
      return pieces.every(function (p) { return !!pieceRadio(p, f.models[p.garment.model]); });
    });
    if (!fams.length) return;
    if (old && old.box.parentNode) old.box.parentNode.removeChild(old.box);
    var id = 'crew-kit-color-' + (++kitColorSeq);
    var box = document.createElement('div');
    box.className = 'crew-kit-color';
    var choiceCount = kitColorChoiceCount(pieces);
    box.innerHTML = '<p class="crew-kit-color__title" id="' + id + '-title">Quick pick: <span class="crew-kit-color__name"></span></p>' +
      '<p class="crew-kit-color__summary" aria-live="polite"></p>' +
      // The Mix tile rides in the same row as the swatches: buyers scan the row of circles
      // and skipped the text link underneath, so the way out has to look like one more choice.
      // It stays OUTSIDE the radiogroup - a button inside a radiogroup breaks the role.
      '<div class="crew-kit-color__picker">' +
      // Past seven swatches a phone row wraps; is-many splits it into even rows instead of leaving a stray pair.
      '<div class="crew-kit-color__swatches' + (fams.length > 7 ? ' is-many' : '') + '" role="radiogroup" aria-labelledby="' + id + '-title"></div>' +
      '<button type="button" class="crew-kit-color__mix" aria-expanded="false">' +
      '<span class="crew-kit-color__mixdot" aria-hidden="true"></span>' +
      '<span class="crew-kit-color__mixtext">Mix</span>' +
      '<span class="crew-kit-color__sr">Mix and match - pick a color for each piece</span>' +
      '</button>' +
      '</div>' +
      '<button type="button" class="crew-kit-color__toggle" aria-expanded="false">More colors or mix and match' +
      (choiceCount > 7 ? ' \u00b7 ' + choiceCount + ' colors' : '') + '</button>';
    var list = box.querySelector('.crew-kit-color__swatches');
    fams.forEach(function (f, i) {
      var input = document.createElement('input');
      input.type = 'radio';
      input.name = id;
      input.id = id + '-' + i;
      input.value = f.name;
      input.className = 'crew-kit-color__input';
      input.setAttribute('form', id + '-none'); // no such form: keeps this chooser out of the cart data
      var label = document.createElement('label');
      label.htmlFor = input.id;
      label.className = 'crew-kit-color__swatch' + (isLightHex(f.hex) ? ' is-light' : '');
      label.title = f.name;
      label.style.setProperty('--swatch', f.hex);
      var text = document.createElement('span');
      text.className = 'crew-kit-color__sr';
      text.textContent = f.name;
      label.appendChild(text);
      list.appendChild(input);
      list.appendChild(label);
    });
    var anchor = pieces[0].select ? (pieces[0].el.closest('.crew-kit-picks__fields') || pieces[0].el) : pieces[0].el;
    anchor.parentNode.insertBefore(box, anchor);
    pieces.forEach(function (p) { p.el.classList.add('crew-kit-piece'); });
    var st = root.__kitColor = { box: box, pieces: pieces, fams: fams, open: false,
      inputs: [].slice.call(list.querySelectorAll('input')), name: box.querySelector('.crew-kit-color__name'),
      summary: box.querySelector('.crew-kit-color__summary'), toggle: box.querySelector('.crew-kit-color__toggle'),
      mix: box.querySelector('.crew-kit-color__mix') };
    // The chooser's own events stop at its box, so Globo's listeners never see a field they do not know.
    box.addEventListener('input', function (e) { e.stopPropagation(); });
    box.addEventListener('change', function (e) {
      e.stopPropagation();
      var f = fams.filter(function (x) { return x.name === e.target.value; })[0];
      if (!f) return;
      st.applying = true;
      pieces.forEach(function (p) {
        var r = pieceRadio(p, f.models[p.garment.model]);
        if (r) pieceSet(p, r);
      });
      st.applying = false;
      syncKitColor(root);
    });
    st.toggle.addEventListener('click', function () { setPiecesOpen(root, !st.open); });
    if (st.mix) st.mix.addEventListener('click', function () {
      setPiecesOpen(root, !st.open);
      if (st.open && st.pieces[0]) st.pieces[0].el.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    });
    var form = root.closest('form');
    if (form && !form.__crewKitColorWatch) {
      form.__crewKitColorWatch = true;
      form.addEventListener('change', function (e) {
        if (e.target && (e.target.type === 'radio' || e.target.tagName === 'SELECT') && e.target.closest('.crew-kit-piece')) syncKitColor(root);
      });
    }
    // Desktop starts OPEN so the per-piece colors are never missed (Evan 2026-09-17); phones start
    // collapsed because the panel adds about 0.7 of a screen above Add to Cart there. Either way it also
    // opens when the pieces do not match a family (a Globo default changed, say), so nothing differing is hidden.
    // Evan 2026-09-17: open on phones too, same as desktop. It costs roughly 0.7 of a screen above Add to
    // Cart on mobile, which he accepted so the per-piece colours are never missed.
    setPiecesOpen(root, old ? old.open : true);
    syncKitColor(root);
  }

  // Fallback logo / color / notes fields. Globo Product Options draws the real ones at runtime.
  // When its code never runs (a content blocker, a failed request, an app outage or a lapsed subscription)
  // the page showed no upload box at all, and Add To Cart sent a kit with no logo or colors.
  // These fields stay hidden and disabled (so nothing extra posts) until Globo is missing. Dawn's product
  // form then posts them as multipart form data, so the logo lands on the order as a Shopify CDN link.
  // Property names match Globo's ("Your logo", "Tees color" ..., "Notes"), so an order reads the same
  // either way. There is no company name step (Evan 2026-09-27: "we really dont need it").
  var FALLBACK_MAX_BYTES = 20 * 1024 * 1024;

  // Evan 2026-09-28: one plain message when the logo is missing, on every kit and single item, Globo or not.
  // It replaces the theme's "Upload your logo to continue..." and Globo's small "This field is required".
  var LOGO_MSG = 'Add your logo first. A photo works.';
  var BIG_MSG = 'That file is over 20 MB. Upload a smaller copy (a screenshot works) and email the full file to info@ftanaples.com.';

  // Clarity custom events (cr_atc_blocked, cr_logo_picked). The Clarity app embed defines window.clarity; when it
  // is blocked or not loaded yet nothing happens.
  function crewTrack(name, tagKey, tagValue) {
    try {
      if (typeof window.clarity !== 'function') return;
      window.clarity('event', name);
      if (tagKey) window.clarity('set', tagKey, tagValue);
    } catch (err) {}
  }

  // Scroll a field into the part of the screen the buyer can see: below the sticky header (63 px, and it slides
  // back in on the way up) and above the phone's sticky buy bar, centered when it fits. Globo's own scroll and
  // scrollIntoView() put the logo box under the header.
  function scrollToNeed(el, form) {
    if (!el || !el.getBoundingClientRect) return;
    var header = document.querySelector('.section-header');
    var top = header ? header.getBoundingClientRect().height : 0;
    var bar = form ? form.querySelector('[data-crew-sticky]') : null;
    var phone = !window.matchMedia || window.matchMedia('(max-width: 749px)').matches;
    var bottom = bar && phone ? (bar.hidden ? (bar.__crewH || 70) : bar.getBoundingClientRect().height) : 0;
    var vh = window.innerHeight || document.documentElement.clientHeight || 0;
    var r = el.getBoundingClientRect();
    var room = vh - top - bottom;
    var gap = r.height < room ? Math.max(12, (room - r.height) / 2) : 12;
    var y = Math.max(0, Math.round(r.top + (window.pageYOffset || document.documentElement.scrollTop || 0) - top - gap));
    try { window.scrollTo({ top: y, behavior: 'smooth' }); } catch (err) { window.scrollTo(0, y); }
  }

  function globoReady(form) {
    return !!(form && form.querySelector('.gpo-container input[type="file"]'));
  }

  // Globo empties its visible file input once an upload finishes and keeps the logo URL in a hidden input,
  // so a field counts as filled when its hidden input has a value, its box has text, a file is still
  // uploading, or its upload card shows.
  function globoHas(form, field) {
    var sel = '.gpo-hidden-inputs [data-field-name="' + field + '"]';
    var hidden = form.querySelector(sel) || document.querySelector(sel);
    if (hidden && String(hidden.value || '').trim()) return true;
    var el = form.querySelector('.gpo-container [name="' + field + '"]');
    if (!el) return false;
    if (el.type === 'file') {
      var g = el.closest('.gpo-element');
      return !!((el.files && el.files.length) || el.hasAttribute('data-has-file') || (g && g.querySelector('.gpo-f-card')));
    }
    return !!String(el.value || '').trim();
  }

  // The first visible required Globo field that is still empty, or null. A company name is never needed, so
  // a Globo company field is skipped even while an option set still marks it required.
  function globoMissing(form) {
    var groups = form.querySelectorAll('.gpo-container .gpo-element');
    for (var i = 0; i < groups.length; i++) {
      var g = groups[i];
      if (g.offsetParent === null || !g.querySelector('label.gpo-label.required')) continue;
      if (!globoGroupFilled(form, g)) return g;
    }
    return null;
  }

  // Whether one Globo field group has what it needs. A group this cannot read counts as filled, so Globo's own
  // check still decides it and a misread can never trap the buyer.
  function globoGroupFilled(form, g) {
    var input = g.querySelector('input:not([type="hidden"]):not([type="radio"]):not([type="checkbox"]), textarea, select');
    if (!input) return g.querySelector('input[type="radio"], input[type="checkbox"]') ? !!g.querySelector('input:checked') : true;
    var name = input.getAttribute('data-field-name') || input.name;
    if (!name || name.indexOf('"') >= 0 || /company/i.test(name)) return true;
    return globoHas(form, name);
  }

  // The message for a missing Globo field: the logo message for the upload box, "Pick a vest color first." for a
  // color, "Fill in the notes first." for a text box.
  function globoNeedText(g) {
    if (g.querySelector('input[type="file"]')) return LOGO_MSG;
    var l = g.querySelector('.label-content') || g.querySelector('label.gpo-label');
    var name = l ? l.textContent.replace(/\*/g, '').replace(/\s+/g, ' ').trim() : '';
    if (!name) return 'Please finish this step first.';
    if (/^[A-Z][a-z]/.test(name)) name = name.charAt(0).toLowerCase() + name.slice(1);
    return (g.querySelector('input[type="radio"], input[type="checkbox"], select') ? 'Pick a ' : 'Fill in the ') + name + ' first.';
  }

  // Show the message right under the field's label and outline the box. Globo's own error line in that group is
  // hidden by CSS while the theme's message shows (crew-kit-form.css, .crew-kit-need-box).
  function showGloboNeed(form, g, scroll) {
    var msg = g.querySelector('[data-crew-need]');
    if (!msg) {
      msg = document.createElement('p');
      msg.className = 'crew-kit-fallback__error crew-kit-need';
      msg.setAttribute('data-crew-need', '');
      msg.setAttribute('role', 'alert');
      var label = g.querySelector('label.gpo-label');
      if (label && label.parentNode === g) label.insertAdjacentElement('afterend', msg); else g.insertBefore(msg, g.firstChild);
    }
    var text = globoNeedText(g);
    if (msg.textContent !== text) msg.textContent = text;
    msg.hidden = false;
    g.classList.add('crew-kit-need-box');
    if (scroll) scrollToNeed(g, form);
  }

  // Runs after Globo redraws (the label observer in watchGlobo) and after a file is picked. Globo's own
  // "This field is required" under the logo box turns into the theme's message, and a message goes away once
  // its field is filled (Globo's upload card showing counts).
  function syncGloboNeed(form) {
    if (!form) return;
    form.querySelectorAll('.gpo-container .gpo-element').forEach(function (g) {
      if (g.classList.contains('crew-kit-need-box') || !g.querySelector('input[type="file"]')) return;
      var err = g.querySelector('.messages .help-block.error');
      if (err && /required/i.test(err.textContent || '')) showGloboNeed(form, g, false);
    });
    form.querySelectorAll('.gpo-container .crew-kit-need-box').forEach(function (g) {
      if (!globoGroupFilled(form, g)) return;
      g.classList.remove('crew-kit-need-box');
      var m = g.querySelector('[data-crew-need]');
      if (m) m.hidden = true;
    });
  }

  function buildFallback(root) {
    var form = root.closest('form');
    if (!form) return null;
    var box = form.querySelector('[data-crew-kit-fallback]');
    if (box) return box;
    var id = 'crew-kit-fallback-' + (++kitColorSeq);
    function label(key, text, required) {
      return '<label class="crew-kit-fallback__label" for="' + id + '-' + key + '">' + text +
        (required ? ' <span class="crew-kit-fallback__req" aria-hidden="true">*</span>' : '') + '</label>';
    }
    // One color for the whole kit, written per garment under Globo's property names. The Executive Package
    // has its own color pickers, so it gets no color field here.
    var pieces = form.querySelector('[data-crew-kit-picks]') ? [] : (root.__crewKit || []).filter(function (g) { return g.color && g.model; });
    var fams = pieces.length < 2 ? [] : KIT_COLORS.filter(function (f) {
      return pieces.every(function (g) { return !!f.models[g.model]; });
    });
    var html = '<div class="crew-kit-fallback__field">' + label('logo', 'Upload your logo (highest quality file you have)', true) +
      '<p class="crew-kit-fallback__error" data-crew-kit-fallback-error role="alert" hidden></p>' +
      '<input type="file" id="' + id + '-logo" name="properties[Your logo]" data-fallback="logo" required disabled>' +
      '<span class="crew-kit-fallback__help">Upload the highest quality logo file you have. A vector file (AI, EPS, PDF, SVG) is best. If your logo needs to be redrawn, we\'re happy to help and can make you a vector file for a small fee. Any image, PDF, AI or ZIP up to 20 MB.</span></div>';
    if (fams.length) {
      html += '<div class="crew-kit-fallback__field">' + label('color', 'Kit color', false) +
        '<select id="' + id + '-color" data-fallback="color" disabled>' +
        fams.map(function (f) { return '<option value="' + f.name + '"' + (f.name === 'Grey' ? ' selected' : '') + '>' + f.name + '</option>'; }).join('') +
        '</select><span class="crew-kit-fallback__help">Every piece in this color. Want a mix? Tell us in the notes.</span>' +
        pieces.map(function (g) { return '<input type="hidden" name="properties[' + g.label + ' color]" data-fallback="piece" data-model="' + g.model + '" disabled>'; }).join('') +
        '</div>';
    }
    html += '<div class="crew-kit-fallback__field">' + label('notes', 'Notes for our art team (optional)', false) +
      '<textarea id="' + id + '-notes" name="properties[Notes]" data-fallback="notes" rows="3" placeholder="' + (root.hasAttribute('data-single') ? 'Logo colors, logo size, placement, anything else we should know' : 'Logo colors, a tagline or phone number on the back, placement, anything else we should know') + '" disabled></textarea></div>';
    box = document.createElement('div');
    box.className = 'crew-kit-fallback';
    box.setAttribute('data-crew-kit-fallback', '');
    box.hidden = true;
    box.innerHTML = html;
    // Evan 2026-10-26/27 (theme-upload kits: hoodie, premium, performance, classic, women's; data-colors-first): the color
    // pick comes before the logo box, so the easy choice is made first and the required upload sits right above the sizes
    // and Add To Cart. Globo kits and single items keep the box on top.
    var block = root.hasAttribute('data-colors-first') ? root : (root.closest('[data-crew-kit-config]') || root);
    block.parentNode.insertBefore(box, block);
    var sel = box.querySelector('[data-fallback="color"]');
    function pieceColors() {
      var fam = sel ? KIT_COLORS.filter(function (f) { return f.name === sel.value; })[0] : null;
      box.querySelectorAll('[data-fallback="piece"]').forEach(function (h) { h.value = fam ? fam.models[h.getAttribute('data-model')] || '' : ''; });
    }
    function unmark(el) {
      if (!el || !el.classList || !el.classList.contains('is-missing')) return;
      if (el.type === 'file' ? el.files && el.files.length : String(el.value || '').trim()) {
        el.classList.remove('is-missing');
        if (el.getAttribute('data-fallback') === 'logo') hideFallbackError(form);
      }
    }
    pieceColors();
    var logoIn = box.querySelector('[data-fallback="logo"]');
    var logoOk = root.hasAttribute('data-single') ? null : buildLogoOk(logoIn);
    // These events stop at the box: nothing else on the page (Dawn's variant code, a late Globo) needs them.
    box.addEventListener('input', function (e) { e.stopPropagation(); unmark(e.target); });
    box.addEventListener('change', function (e) {
      e.stopPropagation();
      if (e.target === sel) pieceColors();
      unmark(e.target);
      if (logoOk && e.target === logoIn) showLogoOk(form, logoIn, logoOk);
    });
    return box;
  }

  // Evan 2026-10-26: once a kit's logo is picked, say what happens next right under the box. No live mockup:
  // the help line invites a photo of a truck or a business card, which would look wrong on a hoodie, so the
  // buyer sees a small thumbnail of their own file and the mockup promise instead. Single items keep the help line.
  function buildLogoOk(logo) {
    var field = logo && logo.closest('.crew-kit-fallback__field');
    if (!field) return null;
    var ok = document.createElement('div');
    ok.className = 'crew-kit-logo-ok';
    ok.setAttribute('data-crew-logo-ok', '');
    ok.setAttribute('role', 'status');
    ok.hidden = true;
    ok.innerHTML = '<span class="crew-kit-logo-ok__thumb" data-crew-logo-thumb aria-hidden="true"></span>' +
      '<span class="crew-kit-logo-ok__text"><strong class="crew-kit-logo-ok__title">Got your logo</strong>' +
      '<span class="crew-kit-logo-ok__name" data-crew-logo-name></span>' +
      '<span class="crew-kit-logo-ok__note">We check your file and email you a mockup to approve within 1 business day. If it needs to be redrawn, we can make you a vector file for a small fee. Nothing gets printed until you approve it.</span></span>';
    field.appendChild(ok);
    return ok;
  }

  // The thumbnail is the picked file itself when the browser can draw it (Chrome cannot draw HEIC phone photos),
  // else a tile with the file type (PDF, AI, ZIP). An over-20 MB file shows the size message straight away
  // instead of waiting for Add To Cart.
  function showLogoOk(form, logo, ok) {
    var field = logo.closest('.crew-kit-fallback__field');
    var file = logo.files && logo.files[0];
    var tooBig = !!file && file.size > FALLBACK_MAX_BYTES;
    if (ok.__url) { try { URL.revokeObjectURL(ok.__url); } catch (err) {} ok.__url = null; }
    ok.hidden = !file || tooBig;
    if (field) field.classList.toggle('has-logo', !ok.hidden);
    if (tooBig) {
      logo.classList.add('is-missing');
      var err = form.querySelector('[data-crew-kit-fallback-error]');
      if (err) { err.textContent = BIG_MSG; err.hidden = false; }
    }
    if (ok.hidden) return;
    var thumb = ok.querySelector('[data-crew-logo-thumb]');
    var m = /\.([a-z0-9]{1,5})$/i.exec(file.name || '');
    function tile() {
      thumb.textContent = '';
      var s = document.createElement('span');
      s.className = 'crew-kit-logo-ok__ext';
      s.textContent = m ? m[1].toUpperCase() : 'FILE';
      thumb.appendChild(s);
    }
    thumb.textContent = '';
    if (/^image\//.test(file.type || '') && window.URL && URL.createObjectURL) {
      var img = document.createElement('img');
      img.alt = '';
      img.onerror = tile;
      ok.__url = URL.createObjectURL(file);
      img.src = ok.__url;
      thumb.appendChild(img);
    } else {
      tile();
    }
    ok.querySelector('[data-crew-logo-name]').textContent = file.name || '';
  }

  function setFallback(form, on) {
    var box = form.querySelector('[data-crew-kit-fallback]');
    if (!box) return;
    form.__crewKitFallbackOn = !!on;
    box.hidden = !on;
    box.querySelectorAll('[data-fallback]').forEach(function (el) { el.disabled = !on; });
    if (!on) hideFallbackError(form);
  }

  // What the buyer still has to fill in on the fallback fields (showing them first if needed), or null.
  function checkFallback(root, mark) {
    var form = root.closest('form');
    var box = form && buildFallback(root);
    if (!box) return null;
    if (!form.__crewKitFallbackOn) setFallback(form, true);
    var logo = box.querySelector('[data-fallback="logo"]');
    var file = logo.files && logo.files[0];
    var tooBig = !!file && file.size > FALLBACK_MAX_BYTES;
    if (mark) logo.classList.toggle('is-missing', !file || tooBig);
    if (!file) return { el: logo, msg: LOGO_MSG };
    if (tooBig) return { el: logo, msg: BIG_MSG };
    return null;
  }

  function showFallbackError(form, missing) {
    var err = form.querySelector('[data-crew-kit-fallback-error]');
    if (err) { err.textContent = missing.msg; err.hidden = false; }
    scrollToNeed(missing.el.closest('.crew-kit-fallback__field') || missing.el, form);
  }

  function hideFallbackError(form) {
    var err = form.querySelector('[data-crew-kit-fallback-error]');
    if (err) err.hidden = true;
  }

  // Globo turned up after the fallback was already showing (a very slow connection). Hand over anything the
  // buyer entered, then switch the fallback off so the kit never carries two sets of fields.
  function retireFallback(root) {
    var form = root.closest('form');
    if (!form || !form.__crewKitFallbackOn || !globoReady(form)) return;
    var box = form.querySelector('[data-crew-kit-fallback]');
    var sel = box.querySelector('[data-fallback="color"]');
    // Wait a moment for the kit color chooser (built from Globo's dropdowns) so the color can be handed over too.
    if (sel && !root.__kitColor && (form.__crewKitRetireTries = (form.__crewKitRetireTries || 0) + 1) < 8) {
      setTimeout(function () { retireFallback(root); }, 400);
      return;
    }
    function put(el, value) {
      if (!el || !value || String(el.value || '').trim()) return;
      el.value = value;
      el.dispatchEvent(new Event('input', { bubbles: true }));
      el.dispatchEvent(new Event('change', { bubbles: true }));
    }
    put(form.querySelector('.gpo-container textarea'), box.querySelector('[data-fallback="notes"]').value.trim());
    var logo = box.querySelector('[data-fallback="logo"]');
    var globoLogo = form.querySelector('.gpo-container input[type="file"]');
    if (logo.files && logo.files.length && globoLogo && !globoHas(form, globoLogo.getAttribute('data-field-name') || globoLogo.name)) {
      try {
        var dt = new DataTransfer();
        dt.items.add(logo.files[0]);
        globoLogo.files = dt.files;
        globoLogo.dispatchEvent(new Event('change', { bubbles: true }));
      } catch (err) { /* Globo's own logo box still says it is required, so the buyer picks the file again there */ }
    }
    var st = root.__kitColor;
    var pick = sel && st ? st.inputs.filter(function (i) { return i.value === sel.value; })[0] : null;
    if (pick && !pick.checked) {
      pick.checked = true;
      pick.dispatchEvent(new Event('change', { bubbles: true }));
    }
    setFallback(form, false);
  }

  function watchForGlobo(root) {
    var form = root.closest('form');
    if (!form || form.__crewKitFallbackWatch) return;
    form.__crewKitFallbackWatch = true;
    buildFallback(root);
    // single items have no Globo option set: show the theme's own logo and notes fields straight away
    if (root.hasAttribute('data-native-fields') && !root.hasAttribute('data-globo-upload')) setFallback(form, true); // data-globo-upload (Hoodie, Crewneck, Beanie Kits, Evan 2026-10-28): wait for Globo's upload like the Crew Kits
    function check() { if (!globoReady(form) && !form.__crewKitFallbackOn) setFallback(form, true); }
    // Globo draws its fields well under a second after the HTML arrives, and about 3.6 s after it on an
    // emulated slow 3G phone (measured 2026-09-14). Past these marks it is not coming.
    setTimeout(check, 8000);
    if (document.readyState === 'complete') setTimeout(check, 3000);
    else window.addEventListener('load', function () { setTimeout(check, 3000); });
  }

  function watchGlobo(root) {
    placeAfterGlobo(root);
    annotateGlobo(root);
    initKitColor(root);
    var form = root.closest('form');
    if (!form || !window.MutationObserver) return;
    var mo = new MutationObserver(function () { placeAfterGlobo(root); });
    mo.observe(form, { childList: true, subtree: false });
    setTimeout(function () { mo.disconnect(); }, 15000);
    var queued = false;
    var labels = new MutationObserver(function () {
      if (queued) return;
      queued = true;
      setTimeout(function () { queued = false; annotateGlobo(root); initKitColor(root); retireFallback(root); syncGloboNeed(form); }, 30);
    });
    labels.observe(form, { childList: true, subtree: true });
  }

  // The sticky buy bar (phones). Evan 2026-09-28: its Add To Cart must really add to cart. A tap presses the real
  // button, so it runs exactly what a press on that button runs: the theme's checks (logo, sizes, the $3 add-on),
  // then Globo's own check and add on the Globo kits, or Dawn's add everywhere else, with every logo, color, size
  // and option property the form carries. When something is missing the check scrolls to it and shows why.
  // Globo hides the original button and shows its own clone after load, and the clone is where Globo checks and
  // adds, so the visible button is looked up on every tap. (The 9/13 version pressed the button captured at init,
  // the hidden original, which skipped Globo's check; that is why the bar only scrolled until now.)
  function initSticky(scope) {
    (scope && scope.querySelectorAll ? scope : document).querySelectorAll('[data-crew-sticky]').forEach(function (bar) {
      if (bar.__crewSticky) return;
      bar.__crewSticky = true;
      var form = bar.closest('form');
      var real = form && form.querySelector('button[name="add"]');
      var tap = bar.querySelector('[data-crew-sticky-add]');
      if (!real || !tap) return;
      function realButton() {
        var clone = form.querySelector('button[name="add"].gpo-clone-atc-button');
        if (clone && clone.offsetParent !== null) return clone;
        var list = form.querySelectorAll('button[name="add"]');
        for (var i = 0; i < list.length; i++) { if (list[i].offsetParent !== null) return list[i]; }
        return real;
      }
      tap.addEventListener('click', function (e) {
        e.preventDefault();
        var btn = realButton();
        // Sold out, or an add already running: show the real button and its state instead of pressing it.
        if (btn.disabled || btn.getAttribute('aria-disabled') === 'true' || btn.classList.contains('loading')) {
          scrollToNeed(btn, form);
          return;
        }
        btn.click();
      });
      // A scroll listener, not an IntersectionObserver: IO is throttled in a hidden document,
      // which makes the bar untestable and can leave it stuck on a backgrounded tab. Show the bar
      // once the buyer is into the page and the real button is not on screen.
      var pending = false;
      function sync() {
        pending = false;
        var r = realButton().getBoundingClientRect();
        var onScreen = r.bottom > 0 && r.top < (window.innerHeight || 0);
        bar.hidden = onScreen || window.scrollY < 400;
        if (!bar.hidden) bar.__crewH = bar.getBoundingClientRect().height || bar.__crewH;
      }
      window.addEventListener('scroll', function () {
        if (pending) return;
        pending = true;
        setTimeout(sync, 80);
      }, { passive: true });
      window.addEventListener('resize', function () { if (!pending) { pending = true; setTimeout(sync, 80); } }, { passive: true });
      sync();
    });
  }

  function init(scope) {
    var doc = scope && scope.querySelectorAll ? scope : document;
    doc.querySelectorAll('[data-crew-kit-picks]').forEach(function (picks) { buildPicks(picks); });
    initLogoChoice(doc);
    initSticky(doc);
    doc.querySelectorAll('[data-crew-kit-sizes]').forEach(function (root) {
      if (root.__crewKitInit) return; // a section reload elsewhere must not reset a chosen mode or wipe typed sizes
      root.__crewKitInit = true;
      build(root);
      initModes(root);
      initSingle(root);
      watchGlobo(root);
      watchForGlobo(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  // A fabric change moves the kit price: Dawn writes the new variant id into the form and fires change on it.
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || t.name !== 'id' || !t.form) return;
    var root = t.form.querySelector('[data-crew-kit-sizes]');
    if (root) onVariantMoved(root);
  });
  function onVariantMoved(root) {
    try {
      syncSleeveFromVariant(root);
      if (applyVariantCounts(root)) {
        update(root);
        var errEl = root.querySelector('[data-crew-kit-error]');
        if (errEl && !errEl.hidden) { var pr = firstProblem(root); if (pr) errEl.textContent = pr; else hideError(root); } // no scroll: the buyer is up at the Shirts buttons
      } else renderSummary(root);
    } catch (err) {}
  }
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, function () {
      document.querySelectorAll('[data-crew-kit-sizes]').forEach(onVariantMoved);
    });
  }
})();


/* Crew Ready (2026-11-03): logo upload wording. Globo Product Options stores its own label and help text for the kit
   upload field, so swap them here until they are changed in Globo too. Same wording as the theme's own fallback field. */
(function () {
  var OLD_LABEL = 'Upload your logo (any photo works)';
  var NEW_LABEL = "Upload your logo (highest quality file you have)";
  var HELP = "Upload the highest quality logo file you have. A vector file (AI, EPS, PDF, SVG) is best. If your logo needs to be redrawn, we're happy to help and can make you a vector file for a small fee. Any image, PDF, AI or ZIP works.";
  function fix(root) {
    if (!root || !root.nodeType) return;
    var w = document.createTreeWalker(root.nodeType === 3 ? root.parentNode || root : root, NodeFilter.SHOW_TEXT), n;
    while ((n = w.nextNode())) {
      var t = n.nodeValue;
      if (t.indexOf(OLD_LABEL) > -1) n.nodeValue = t.replace(OLD_LABEL, NEW_LABEL);
      else if (t.indexOf('No perfect file needed.') > -1) n.nodeValue = HELP;
    }
  }
  function start() {
    fix(document.body);
    new MutationObserver(function (list) {
      list.forEach(function (m) { m.addedNodes.forEach(function (a) { if (a.nodeType === 1 || a.nodeType === 3) fix(a); }); });
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.body) start(); else document.addEventListener('DOMContentLoaded', start);
})();
